import { Component, OnInit, ViewChild, ElementRef, NgZone, HostListener, ViewEncapsulation, OnDestroy, Query } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OauthService} from '../service/oauth.service';
import { UserInterface } from '../models/user';
import { AlarmInterface, RTAlarmsInterface } from '../models/alarm'; 
import { BQRequestService } from '../service/bqrequest.service';
import { ViewobserverService } from '../service/viewobserver.service';
import { MarkersService } from '../service/markers.service';
import { MarkerInterface } from '../models/marker';
import { AlarmsqueryService } from '../service/alarmsquery.service';
import { MatSidenav} from '@angular/material/sidenav';

import { GoogleChartInterface } from 'ng2-google-charts/ng2-google-charts';
import { registerLocaleData } from '@angular/common';

import es from '@angular/common/locales/es';
import { AppComponent } from '../app.component';
import {CompactType, DisplayGrid, Draggable, GridsterConfig, GridsterItem, GridType, PushDirections, Resizable} from 'angular-gridster2';
import { CursorError } from '@angular/compiler/src/ml_parser/lexer';
import { DialogOverviewConfirm } from '../cards/cards.component';
import { MatDialog } from '@angular/material';
//import { elementStyleProp } from '@angular/core/src/render3';

const months = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
//const months = ["E","F","M","A","M","J","J","A","S","O","N","D"];

interface Safe extends GridsterConfig{
  draggable: Draggable;
  resizable: Resizable;
  pushDirections: PushDirections;
}


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('sideNav', { static: true }) sidenav: MatSidenav;
  @ViewChild('search', { static: false }) searchElementRef: ElementRef;
  @ViewChild('widgets', { static: false }) widgetsElementRef: MatSidenav;

  //-------------------- Gridster ---------------------
  options: Safe;  
  public dashboard: Array<GridsterItem>;
  public dashObjs;
  public TabIndex = "";

  public cssClassNames = {
    'headerRow': 'GchartHeader',
    'tableRow': 'GchartRow',
    'oddTableRow': 'GchartRowOdd'
    };

  public TableMap: GoogleChartInterface ={
    chartType: 'Table',
    dataTable: [
      ["Descripcion", "PMTC1", "PM_EXTRACTOR", "PMTC2", "PMTC3"],
      ["Ausencia de Voltaje en Fase 2 - Rest.", 52, 0, 33, 11],
      ["Ausencia de Voltaje en Fase 1 - Rest.", 50, 0, 31, 9],
      ["Ausencia de Voltaje en Fase 2", 3, 0, 1, 0],
      ["Sobrecarga en Fase 1 - Rest.", 0, 2, 0, 0],
      ["Sobrecarga en Fase 1", 0, 1, 0, 0],
      ["Ausencia de Voltaje en Fase 3 - Rest.", 1, 0, 2, 1],
      ["Ausencia de Voltaje en Fase 1", 4, 0, 1, 0],
      ["Ausencia de Voltaje en Fase 3", 0, 0, 0, 1],
   ],
   options: {
     cssClassNames: this.cssClassNames
    }
  }

  //---------------------------------------------------
  public CompareBarsChart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [
      ['Consumidor', 'Acumulado, mes actual', 'Proyectado, mes actual', 'Mes anterior, año actual', 'Mismo mes, año anterior'],
      [' ',  0, 0, 0, 0]
    ],
    options: { legend: {position: 'top', textStyle:{fontSize: 7, color: '#3f6ab7', fontName: 'Arial Black'}},
    title: 'CONSUMOS ELÉCTRICOS COMPARATIVOS (kWh)',
    titleTextStyle: {fontSize: 12, bold: true, color: '#3f6ab7'},
    borderWidth: 1,
    height: 270,
    chartArea: { left: 60, right: 10, top: 50, bottom: 40, height: '80%'}, 
    animation: {duration: 800, easing: 'inAndOut'},
    hAxis: {
      visible: 'true',
      textStyle:{color: '#3f6ab7'},
      textPosition: 'left'
      
     },
    vAxis: {
      format: "short",
      visible: 'true',
      textStyle:{color: '#3f6ab7'},
      titleTextStyle:{color: 'white'},
      gridlines: {color: 'gray'},
      position: 'in',
      viewWindow: {
                    min:0
                  }
    },
    options: {
      responsive: true
    },

     colors: ['#4875c5', '#a8a8a8', '#619dd6', '#2f4b80'],

     lineWidth: 2.8,

    pointShape: "circle",
    pointSize: 4, 
    pointSizeShadow: 0,
    forcelFrame: "true",
    curveType: "linear",
               
    }
  };

  public MonthsUSDChart: GoogleChartInterface = {
    chartType: 'LineChart',
    dataTable: [
      ['M-A', 'CONSUMO (USD)', 'Linea Base (USD)'],
      [' ',  0, 0]
    ],
    options: { legend: {position: 'top', textStyle:{color: '#3f6ab7', fontName: 'Arial Black'}},
    borderWidth: 1,
    height: 250,
    chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
    animation: {duration: 800, easing: 'inAndOut'},
    hAxis: {
      visible: 'true',
      textPosition: 'left',
      textStyle:{color: '#3f6ab7'},
      
     },
    vAxis: {
      format: "short",
      visible: 'true',
      textStyle:{color: '#3f6ab7'},
      titleTextStyle:{color: 'white'},
      gridlines: {color: 'gray'},
      position: 'in',
      viewWindow: {
                    min:0
                  }
    },
    series: {
      0: {pointsVisible: true},
      1: {type: 'line',lineDashStyle: [10, 2]}},
    options: {
      responsive: true
    },

    //  colors: ['#4875c5', '#a8a8a8', '#619dd6', '#2f4b80'],

     lineWidth: 2.8,

    // pointShape: "circle",
    // pointSize: 4, 
    // pointSizeShadow: 0,
    forcelFrame: "true",

     curveType: "linear",
               
              }
  };

  public co2Chart: GoogleChartInterface = {
    chartType: 'AreaChart',
    dataTable: [
      ['M-A', 'Ton CO2' ],
      [' ',  0]
    ],
    options: { 
      legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
      borderWidth: 1,
      height: 270,
      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
      animation: {duration: 800, easing: 'inAndOut'},      
      hAxis: {
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        textPosition: 'left',
        ticks: [{v: 0, f:'Jan'},{v: 1, f:'Feb'},{v: 2, f:'Mar'},{v: 3, f:'Apr'}],
      },
      vAxis: {
        format: "short",
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        titleTextStyle:{color: 'white'},
        gridlines: {color: 'gray'},
        position: 'in',
        viewWindow: {
                      min:0
                    }
      },
      colors: ['#A8A8A8'],
      lineWidth: 2.8,
      pointShape: "circle",
      pointSize: 4, 
      pointSizeShadow: 0,
      forcelFrame: "true",
      curveType: "linear",      
      trendlines: {
        0: {
            type: 'polynomial',
            degree: 3,
            color: 'red',
            lineWidth: 1.5,
            opacity: 0.2,
            pointsVisible: false
        }
      }
    }
  };

  public KPI1Chart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [
      ['M-A', 'KPI Consumo/Ventas (%)' ],
      [' ',  0],
    ],
    options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
    borderWidth: 1,
    height: 270,
    chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
    animation: {duration: 800, easing: 'inAndOut'},
    hAxis: {
      visible: 'true',
      textStyle:{color: '#3f6ab7'},
      textPosition: 'left'
      
     },
    vAxis: {
      format: "short",
      visible: 'true',
      textStyle:{color: '#3f6ab7'},
      titleTextStyle:{color: 'white'},
      gridlines: {color: 'gray'},
      position: 'in',
      viewWindow: {
                    min:0
                  }
    },
    colors: ['#4875C5'],
    lineWidth: 2.8,
    pointShape: "circle",
    pointSize: 4, 
    pointSizeShadow: 0,
    forcelFrame: "true",
    curveType: "linear",      
    trendlines: {
      0: {
          type: 'linear',
          degree: 3,
          color: 'red',
          lineWidth: 1.5,
          opacity: 0.2,
          pointsVisible: false
      }
    }
    
              }
  };

  public KPI2Chart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [
      ['M-A', 'KPI Consumo/Área (USD/m2)' ],
      [' ',  0],
    ],
    options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
    borderWidth: 1,
    height: 270,
    chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
    animation: {duration: 800, easing: 'inAndOut'},
    hAxis: {
      visible: 'true',
      textStyle:{color: '#3f6ab7'},
      textPosition: 'left'
      
     },
    vAxis: {
      format: "short",
      visible: 'true',
      textStyle:{color: '#3f6ab7'},
      titleTextStyle:{color: 'white'},
      gridlines: {color: 'gray'},
      position: 'in',
      viewWindow: {
                    min:0
                  }
    },
    colors: ['#DC3912'],
    lineWidth: 2.8,
    pointShape: "circle",
    pointSize: 4, 
    pointSizeShadow: 0,
    forcelFrame: "true",
    curveType: "linear",      
    trendlines: {
      0: {
          type: 'polynomial',
          degree: 3,
          color: 'red',
          lineWidth: 1.5,
          opacity: 0.2,
          pointsVisible: false
      }
    }
               
              }
  };
  
  public KPI3Chart: GoogleChartInterface = {
    chartType: 'ColumnChart',
    dataTable: [
      ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
      [' ',  0],
    ],
    options: { 
      legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
      borderWidth: 1,
      height: 270,
      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
      animation: {duration: 800, easing: 'inAndOut'},
      hAxis: {
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        textPosition: 'left'
        
      },
      vAxis: {
        format: "short",
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        titleTextStyle:{color: 'white'},
        gridlines: {color: 'gray'},
        position: 'in',
        viewWindow: {
                      min:0
                    }
      },
      colors: ['#72b133'],
      lineWidth: 2.8,

      pointShape: "circle",
      pointSize: 4, 
      pointSizeShadow: 0,
      forcelFrame: "true",
      curveType: "linear",      
      trendlines: {
        0: {
            type: 'polynomial',
            degree: 3,
            color: 'red',
            lineWidth: 1.5,
            opacity: 0.2,
            pointsVisible: false
        }
      }           
    }
  };

  public consumersChart: GoogleChartInterface = {
    chartType: 'PieChart',
    dataTable: [
      ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
      [' ',  0]
    ],
    options: { legend: {position: 'right', textStyle:{color: '#3f6ab7', fontSize: 7}},
    borderWidth: 1,
    height: 255,
    chartArea: { left: 5, right: 10, top: 30, height: '80%'}, 
    animation: {duration: 800, easing: 'inAndOut'},
    hAxis: {
      visible: 'true',
      textPosition: 'left'
      
     },
    vAxis: {
      format: "short",
      visible: 'true',
      // textStyle:{color: '#FFF'},
      titleTextStyle:{color: 'white'},
      gridlines: {color: 'gray'},
      position: 'in',
      viewWindow: {
                    min:0
                  }
    },
    lineWidth: 2.8,
    //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
    pointShape: "circle",
    pointSize: 4, 
    pointSizeShadow: 0,
    forcelFrame: "true",

     curveType: "linear",
               
              }
  };

  public Proyections =  [
    {
      "consumidor" : "Refrigeracion",
      "kwh" : 830.12,
      "usd" : 74.71
    },
    {
      "consumidor" : "Congelacion",
      "kwh" : 1237.81,
      "usd" : 111.40
    },
    {
      "consumidor" : "Calientes",
      "kwh" : 1520.31,
      "usd" : 136.82
    },
    {
      "consumidor" : "Aires",
      "kwh" : 812.43,
      "usd" : 73.11
    },
    {
      "consumidor" : "Iluminacion",
      "kwh" : 670.89,
      "usd" : 60.38
    },
    {
      "consumidor" : "UPS",
      "kwh" : 198.45,
      "usd" : 17.86
    },
    {
      "consumidor" : "Otros",
      "kwh" : 462.34,
      "usd" : 41.61
    }
  ];

  public Sales =  [
    {
      "Sito" : "R012",
      "usd" : 3500
    },
    {
      "Sito" : "R012",
      "usd" : 5600
    },
    {
      "Sito" : "R012",
      "usd" : 6200
    }
  ];

  public DieselUsed = [
    {
      "Sito" : "R012",
      "gal" : 2
    },
    {
      "Sito" : "R012",
      "gal" : 3.6
    },
    {
      "Sito" : "R012",
      "gal" : 3.8
    }];

  public GasUsed = [
    {
      "Sito" : "R012",
      "gasm3" : 54
    },
    {
      "Sito" : "R012",
      "gasm3" : 170
    },
    {
      "Sito" : "R012",
      "gasm3" : 189
    }];
  

  public T2headers = ["Mes", "consumousd", "ahorrousd", "electricidadkwh", "dieselgal", "gasm3", "consumoenergia", "emisionestonco2", "ventasusd", "KPI1", "KPI2", "KPI3"]
  public t2rows = [{"Mes": 'Ene-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Feb-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Mar-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Abr-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'May-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Jun-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Jul-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Ago-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Sep-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Oct-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Nov-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},
  {"Mes": 'Dic-20',  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0},]

  // public Theaders = ["consumidor", "kwh", "usd", "kwh2", "usd2", "kwh3", "usd3", "index1", "kwh4", "usd4", "index2"];
  public Theaders = ["consumidor", "kwh4", "usd4", "kwh", "usd", "kwh2", "usd2", "index2"];
  public rows = [
    {
      "consumidor" : "Refrigeracion",
      "kwh" : "0",
      "usd" : "0",
      "kwh2" : "0",
      "usd2" : "0",
      "kwh3" : "0",
      "usd3" : "0",
      "index1": "neut",
      "kwh4" : "0",
      "usd4" : "0",
      "index2": "neut"
    },
    {
      "consumidor" : "Congelacion",
      "kwh" : "0",
      "usd" : "0",
      "kwh2" : "0",
      "usd2" : "0",
      "kwh3" : "0",
      "usd3" : "0",
      "index1": "neut",
      "kwh4" : "0",
      "usd4" : "0",
      "index2": "neut"
    },
    {
      "consumidor" : "Calientes",
      "kwh" : "0",
      "usd" : "0",
      "kwh2" : "0",
      "usd2" : "0",
      "kwh3" : "0",
      "usd3" : "0",
      "index1": "neut",
      "kwh4" : "0",
      "usd4" : "0",
      "index2": "neut"
    },
    {
      "consumidor" : "Aires",
      "kwh" : "0",
      "usd" : "0",
      "kwh2" : "0",
      "usd2" : "0",
      "kwh3" : "0",
      "usd3" : "0",
      "index1": "neut",
      "kwh4" : "0",
      "usd4" : "0",
      "index2": "neut"
    },
    {
      "consumidor" : "Iluminacion",
      "kwh" : "0",
      "usd" : "0",
      "kwh2" : "0",
      "usd2" : "0",
      "kwh3" : "0",
      "usd3" : "0",
      "index1": "neut",
      "kwh4" : "0",
      "usd4" : "0",
      "index2": "neut"
    },
    {
      "consumidor" : "UPS",
      "kwh" : "0",
      "usd" : "0",
      "kwh2" : "0",
      "usd2" : "0",
      "kwh3" : "0",
      "usd3" : "0",
      "index1": "neut",
      "kwh4" : "0",
      "usd4" : "0",
      "index2": "neut"
    },
    {
      "consumidor" : "Equipos Varios",
      "kwh" : "0",
      "usd" : "0",
      "kwh2" : "0",
      "usd2" : "0",
      "kwh3" : "0",
      "usd3" : "0",
      "index1": "neut",
      "kwh4" : "0",
      "usd4" : "0",
      "index2": "neut"
    }
  ];

  public MonthdateControl = new FormControl();
  public InitialLoadingPromise = Promise.resolve(true); 

  setSize(chart){
    this.delay(150).then(any=>{

      let ccComponent = this.CompareBarsChart.component;
      let ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();

      ccComponent = this.MonthsUSDChart.component;
      ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();

      ccComponent = this.co2Chart.component;
      ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();

      ccComponent = this.KPI1Chart.component;
      ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();

      ccComponent = this.KPI2Chart.component;
      ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();

      ccComponent = this.KPI3Chart.component;
      ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();

      ccComponent = this.consumersChart.component;
      ccwrapper = ccComponent.wrapper;
      //redraw
      ccComponent.draw();

      let size = Math.round( window.innerHeight / (100/60)) ;
      
      for(let s in this.dashboard)
      {
        if(this.dashboard[s].chart != undefined)
        {
          ccComponent = this.dashboard[s].chart.component;
          ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();
        }
      }
    })
    
  }
  
  //---------------------------------------------------
  public TopSelector = new FormControl();
  public TopLvlSelected = '';
  public topLevel;
  public MidSelector = new FormControl();
  public MidLvlSelected = '';
  public midLevel;
  public LastSelector = new FormControl();
  public LastLvlSelected = '';
  public lastLevel;
   //---------------------------------------------------
  public alarmdet: any[] = [];
  private subMarkers: any;
  private subObserver: any;
  private subAlarms: any;
  public LevelTitle = ''; //muestra el titulo del nivel actual en tarjeta
  public isloadingTable = false; //variable para mostrar animacion de consulta a BD
  public isloadingDays = false; //espera por tabla de dias.
  public Loadingsites = false;
  public LoadingLastConsumers = false;
  public isloadingDone = false;
  public devsTooltip;
  public currentLvl = 0; //indice de nivel actual en el arbol
  public devsLvl; //lista de dispositivos
  public tree = {}; //Guarda el arbol de sites
  public lastLvlTtip: any; //Esto deja ver el siguiente nivel en tooltips
  public sites: any[] = [];
  public originalQuery: any[] = [];
  // [
  //   {bd_id: "Sierra-Quito-DoralMariscal"},
  //   {bd_id: "Sierra-Cumbaya-PaseoSanFrancisco"},
  //   {bd_id: "Sierra-Checa-Calle"},
  //   {bd_id: "Sierra-Pifo-LaQuintaescencia"},
  //   {bd_id: "Sierra-Quito-ElPortal"},
  //   {bd_id: "Costa-Guayaquil-MalldelSol"},
  //   {bd_id: "Costa-SantoDomingo-PlazaVial"},
  //   {bd_id: "Costa-Manta-PaseoShopping"},
  //   {bd_id: "Costa-Guayaquil-PuertasdelSol"},
  // ];

  public falseQuery = [
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Calientes', 'Fecha': '2020-09-30', 'valor': 1232.06, 'valor_usd': 110.88},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'UPS', 'Fecha': '2020-09-30', 'valor': 203.18, 'valor_usd': 18.28},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Refrigeracion', 'Fecha': '2020-09-30', 'valor': 842.99, 'valor_usd': 75.86},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Congelacion', 'Fecha': '2020-09-30', 'valor': 855.95, 'valor_usd': 77.03},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Iluminacion', 'Fecha': '2020-09-30', 'valor': 229.12, 'valor_usd': 20.62},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Aires', 'Fecha': '2020-09-30', 'valor': 665.74, 'valor_usd': 59.91},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Otros', 'Fecha': '2020-09-30', 'valor': 293.96, 'valor_usd': 26.45},
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Calientes', 'Fecha': '2020-10-31', 'valor': 1711.25, 'valor_usd': 154.01},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'UPS', 'Fecha': '2020-10-31', 'valor': 222.92, 'valor_usd': 20.06},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Refrigeracion', 'Fecha': '2020-10-31', 'valor': 950.69, 'valor_usd': 85.56},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Congelacion', 'Fecha': '2020-10-31', 'valor': 1527.66, 'valor_usd': 137.48},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Iluminacion', 'Fecha': '2020-10-31', 'valor': 694.99, 'valor_usd': 62.54},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Aires', 'Fecha': '2020-10-31', 'valor': 911.35, 'valor_usd': 82.02},
    {'Region': 'Sierra', 'Ciudad': 'Quito', 'Sitio': 'R012', 'consumidor': 'Otros', 'Fecha': '2020-10-31', 'valor': 544.19, 'valor_usd': 48.97}

  ];

  public false_last_month_original =[
    // {'Zone': 'Sierra', 'City': 'Quito', 'Sitio': 'R012', 'kWh': 4323, 'Agua': 0, 'Gas': 0, 'Diesel': 0, 'usd': 389.07,'Fecha': '2020-09-30'},
    // {'Zone': 'Sierra', 'City': 'Quito', 'Sitio': 'R012', 'kWh': 6556.5, 'Agua': 0, 'Gas': 0, 'Diesel': 0, 'usd': 590.08,'Fecha': '2020-10-31'}
  ];

  public false_last_month_predict =[
    {'Zone': 'Sierra', 'City': 'Quito', 'Sitio': 'R012', 'kWh': 0, 'Agua': 0, 'Gas': 0, 'Diesel': 0, 'Fecha': '2020-09-15'}
  ];

  public otherData = [];
  public Snames = ['Gerencial', 'Personalizado'];
  public SpaceLimit;
  public Spaces = [];
  public TotalCurrentkwh = 0;
  public TotalCurrentusd = 0;
  public TotalProykwh = 0;
  public TotalProyusd = 0;
  public TotalLastYrkwh = 0;
  public TotalLastYrusd = 0;
  public TotalLastMnthkwh = 0;
  public TotalLastMnthusd = 0;

  public LastMonthkWh = 0;
  public LastMonthDiesel = 0;
  public LastMonthGas = 0;
  public LastMonthAgua = 0;
  public LastMonthtoCompare = '';

  public LastMonthProykWh = 0;
  public LastMonthProyUSD = 0;

  public OriginalBLQuery = [];
  dummy = new Date();
  public minDate = new Date(this.dummy.setFullYear(this.dummy.getFullYear() - 1)); //one year back
  public today = new Date();

  public Activealarms = 0;
  //   {
  //     'status': 'activa',
  //     'type': 'alta',
  //     'value': values[paramEval],
  //     'desc': desc,
  //     'city': '{}/{}'.format(city, office),
  //     'office': self.GObject.deviceId,
  //     'zone': zone,
  //     'timedate': str(datetime.datetime.now(pytz.timezone("America/Bogota")).strftime("%Y-%m-%d %H:%M:%S"))
  // }
  // ]

  public LastmonthTodateTotal_Energy: any = 0;
  public LastmonthTodateTotal_Diesel: any = 0;
  public LastmonthTodateTotal_Gas: any = 0;
  public LastmonthTodateTotal_Agua: any = 0;


  public monthTodateTotal_Energy: any = 0;
  public monthTodateProm_Energy: any = 0;
  public monthTodateTotal_Diesel: any = 0;
  public monthTodateProm_Diesel: any = 0;
  public monthTodateTotal_Gas: any = 0;
  public monthTodateProm_Gas: any = 0;
  public monthTodateTotal_Agua: any = 0;
  public monthTodateProm_Agua: any = 0;

  public sub: any;
  public Data: any;
  public consumersNames: [];
  public Months: any[] = [];
  public Electr: any[] = [];
  public Electr_usd: any[] = [];
  public Savings: any[] = [];
  public KPI1_list: any[]= [];
  public KPI2_list: any[]= [];
  public KPI3_list: any[]= [];
  public PromUSDSavings: any = 0;
  public PromElectr: any = 0;
  public PromElectrUSD: any = 0;
  public PromKPI1: any = 0;
  public PromKPI2: any = 0;
  public PromKPI3: any = 0;
  public PromSales: any = 0;
  public Diesel: any[] = [];
  public PromDiesel: any = 0;
  public Gas: any[] = [];
  public PromGas: any = 0;
  public Agua: any[] = [];
  public PromAgua: any = 0;
  public Tonco2: any[] = [];
  public PromTonco2: any = 0;
  public kwhm2: any[] = [];
  public Promkwhm2: any = 0;
  public m3_usr: any[] = [];
  public Promm3_usr: any = 0;
  public totalkwh: any[] = [];
  public Promtotalkwh: any = 0;
  
  public Blines: any[] = [];  //objeto que guarda todos los sites y lineas base
  public BL_kWh = 0;
  public BL_Diesel = 0;
  public BL_Agua = 0;
  public BL_Gas = 0;

  public equivalentTooltip: any;

  public Nivel= "Nivel País"
  public AcumulatedCurrentMonth = '-';
  public ProyectedCurrentMonth = '-';
  public LastYrCurrentMonth = '-';
  public TableLastMonth = '-';
  public LookingCurrentMonth = true;

  public ParamsQueryDaily = [];
  public ParamsQueryLastMonth = [];

  public firstLvl = [];
  public midLvl = [];
  public midLvlSelected = '';
  public lastLvl = [];
  public lastLvlSelected = '';
  public siteLvlSelected = '';
  isMobile: boolean = false;
  markers: MarkerInterface[];
  alarms: AlarmInterface[];
  myNewDims: any;
  myNewDims2: any;
  user: UserInterface = {
    name: '',
    photoUrl: '',
    isLogged: false,
    email: '',
    notification: false,
    roles: { 
      viewer: false,
      admin: false,
    },
  };

  constructor(private authService: OauthService, 
    private observer: ViewobserverService,
    private markersService: MarkersService,
    public dialog: MatDialog,
    private requestService: BQRequestService,
    private alarmService: AlarmsqueryService,
    private ngZone: NgZone,
    private app: AppComponent) {}

  ngOnInit() {
    this.options = {
      gridType: GridType.VerticalFixed,
      compactType: CompactType.None,
      margin: 5,
      outerMargin: true,
      outerMarginTop: null,
      outerMarginRight: null,
      outerMarginBottom: null,
      outerMarginLeft: null,
      useTransformPositioning: true,
      mobileBreakpoint: 640,
      minCols: 8,
      maxCols: 8,
      minRows: 4,
      //maxRows: 4,
      maxItemCols: 100,
      minItemCols: 1,
      maxItemRows: 100,
      minItemRows: 1,
      maxItemArea: 2500,
      minItemArea: 1,
      defaultItemCols: 1,
      defaultItemRows: 1,
      fixedColWidth: 255,
      fixedRowHeight: 150,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 10,
      scrollSpeed: 20,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,
      enableOccupiedCellDrop: false,
      emptyCellDragMaxCols: 50,
      emptyCellDragMaxRows: 50,
      ignoreMarginInRow: false,
      draggable: {
        enabled: false,
        stop: function (event, $element, widget) {
          if($element['drag']['lastMouse']['clientX'] != 0 || $element['drag']['lastMouse']['clientY'] != 0)
          {this.updateOnExit = true;};
        }.bind(this)
      },
      resizable: {
        enabled: true,
        stop: function(event, $element){
          this.setSize();
        }.bind(this)
      },
      swap: true,
      pushItems: false,
      disablePushOnDrag: false,
      disablePushOnResize: false,
      pushDirections: {north: true, east: true, south: true, west: true},
      pushResizeItems: false,
      displayGrid: DisplayGrid.OnDragAndResize,
      disableWindowResize: false,
      disableWarnings: false,
      scrollToNewItems: false
    };
    //-------------------------------------------

    this.dashboard = [
      {cols: 2, rows: 2, y: 2, x: 0, dragEnabled: false, widgetType: 'PieConsumers', resizeEnabled: true, minItemCols: 2, label: 'Consumidores Pastel', dataset: null, chart: this.consumersChart},
      {cols: 4, rows: 2, y: 0, x: 0, dragEnabled: false, widgetType: 'GeneralChart', resizeEnabled: true, minItemCols: 2, label: 'Tabla 1'},
      {cols: 4, rows: 2, y: 0, x: 4, dragEnabled: true, widgetType: 'Trendline', resizeEnabled: true, minItemCols: 2, label: 'Grafico', chart: this.MonthsUSDChart},
      {cols: 3, rows: 2, y: 4, x: 5, dragEnabled: false, widgetType: 'Alarms', resizeEnabled: true, minItemCols: 2, label: 'Historico'},
      {cols: 2, rows: 2, y: 2, x: 2, dragEnabled: false, widgetType: 'KPI1', resizeEnabled: true, minItemCols: 2, label: 'KPI1', chart: this.co2Chart},
      {cols: 2, rows: 2, y: 2, x: 4, dragEnabled: false, widgetType: 'KPI2', resizeEnabled: true, minItemCols: 2, label: 'KPI2', dataset: null, chart: this.KPI2Chart},
      {cols: 2, rows: 2, y: 2, x: 6, dragEnabled: false, widgetType: 'KPI3', resizeEnabled: true, minItemCols: 2, label: 'KPI3', dataset: null, chart: this.KPI3Chart},
      {cols: 5, rows: 2, y: 4, x: 0, dragEnabled: false, widgetType: 'YearChart', resizeEnabled: true, minItemCols: 2, label: 'Hitorico 1 Año'},
    ];
    
    // document.addEventListener('wheel', (evt) => {
    //   // ... do stuff with evt
    // }, {
    //   capture: true,
    //   passive: true
    // })
    this.app.sidenav.close();
    document.getElementById('ad').className = 'nav-options mat-button';
    registerLocaleData( es );
    this.myNewDims = window.innerHeight -46;
    this.myNewDims2 = window.innerHeight -88;
    this.ChangeSpaceTab('Gerencial');

    //Actualizo el valor del date control para poder comparar en seleccion
    const currentDate = new Date();
    let lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const formattedMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const lastMonthToCompare = `${months[currentDate.getMonth() - 1]}-${currentDate.getFullYear()}`;

    this.MonthdateControl.setValue(lastDayOfMonth);
    this.MonthdateControl.updateValueAndValidity();
    this.LastMonthtoCompare = lastMonthToCompare;
    
    // consigue los consumidores si no hay datos.
    let conssub = this.markersService.getConsumersNames().subscribe(consumers =>{
      this.consumersNames = consumers['consumidores'];
      conssub.unsubscribe();
    })


    //retrieves the markers to place in map
    this.subMarkers = this.markersService.getMarkers().subscribe(marker =>{
      this.setSize(null);
      this.sites = [];
      this.Blines = [];
      this.markers = marker;
      let sitespreproc = [];
      for (let index = 0; index < this.markers.length; index++){
        this.sites.push({'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office, 'index': index, 'm2': this.markers[index].m2, 'users': this.markers[index].usuarios})
        sitespreproc.push({'zone': this.markers[index].zone, 'city': this.markers[index].city, 'site': this.markers[index].office, 'BL_elec': this.markers[index].LineaB_kWh, 'tarifa_kwh': this.markers[index].tarifa_kwh, 'BL_diesel': this.markers[index].LineaB_diesel, 'tarifa_diesel': this.markers[index].tarifa_diesel ,'BL_gas': this.markers[index].LineaB_Gas, 'tarifa_gas': this.markers[index].tarifa_gas, 'BL_agua': this.markers[index].LineaB_Agua, 'tarifa_agua': this.markers[index].tarifa_agua, 'users': this.markers[index].usuarios, 'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office});
        //aqui se cargan las proyecciones?

      }
      this.OriginalBLQuery = sitespreproc;
      this.createTree();
      this.topLevel = Object.keys(this.tree);
      this.midLevel = [];
      this.lastLevel = [];
      //con esto relleno el selector del centro con las ciudades
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          this.midLevel.push(dummy[inds]);
        }
      }
      //con esto relleno el selector final con los sitios
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
          for(let last in dummy2)
          {
            this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
            
          }
        }
      }

      //aqui traigo otros datos que no se miden en GVC
      let eh = this.alarmService.getOtherData().subscribe(result =>{
        this.otherData = [];
        for(let i in result){
          let m2 = this.getm2FromList(result[i]['Place']);
          let users = this.getUsersFromList(result[i]['Place']);
          let dummy = result[i]['Place'];
          dummy = dummy.split('-');
          let zone = dummy[0];
          let city = dummy[1];
          let site = dummy[2];
          this.otherData.push({date: new Date(result[i]['Fecha']), place: result[i]['Place'],gas: result[i]['Gas'], diesel: result[i]['Diesel'], sales: result[i]['Ventas'], id: result[i]['id'], m2: m2, users: users, Zone: zone, City: city, Sitio: site})
        }
        this.otherData.sort(this.dynamicSort('date'));
        this.Loadingsites = true; //para actualizar el contenido de lo cargado desde BD
        this.updateOnetime();
      })
      this.subMarkers.unsubscribe();      
      
    })
    
    //Aqui la consulta a BD por indices + KPI
    this.sub = this.requestService.sendIndexesRequest().subscribe(result =>{
      if(result[0])
      {
        this.Data = result;
        let firstM = this.Data[0][10]
        this.minDate = new Date(firstM); 
        this.minDate = new Date(this.minDate.setMonth(this.minDate.getMonth() + 1)); //one Month ahead

        let YearInit = this.Data[0][10].split('-')[0];
        let YearInitCopy = YearInit;
        let firstMCopy = this.Data[0][10].split('-')[1];

        let NewDate = new Date();
        let thisYear = NewDate.getFullYear();
        let LastYear = thisYear - 1;
        let thisMonth = months[NewDate.getMonth()];
        let thisDay = new Date().getDate() - 1;
        let datesDummy = this.Data[this.Data.length - 1][10]
        let LastMonth = datesDummy.split('-')[1]
        LastMonth = months[parseInt(LastMonth) - 1];
        let LastDYear = parseInt(datesDummy.split('-')[0]);

        if(thisDay == 0)
        {
          this.AcumulatedCurrentMonth = [thisMonth, thisYear].join('-');
        }else{this.AcumulatedCurrentMonth = [thisDay, thisMonth, thisYear].join('-');}
        
        this.ProyectedCurrentMonth = [lastDayOfMonth.getDate(), thisMonth, thisYear].join('-');
        this.LastYrCurrentMonth = [thisMonth, LastYear].join('-');
        this.TableLastMonth = [LastMonth, LastDYear].join('-');

        

        firstM = firstM.split('-');
        firstM = parseInt(firstM[1]) - 1;
        let yearone = true;
        //Esto Rellena un año completo con datos desde Query
        for(let x=firstM; x <  firstM+12; x++){
          if(x>11){
            if(yearone){
            YearInit = parseInt(YearInit) + 1
            YearInit = String(YearInit);
            yearone = false;
            }
            this.Months.push(months[x-12]+"-"+YearInit.slice(-2));
          
          }
          else{
            this.Months.push(months[x]+"-"+YearInit);
          }
        } 
        
        //relleno variable con los datos completos en objeto
        for(let item in this.Data){
          this.originalQuery.push({"Region": this.Data[item][0], "Ciudad": this.Data[item][1], "Sitio": this.Data[item][2],"kWh": this.Data[item][3], "Diesel": this.Data[item][7], "Gas": this.Data[item][8], "Agua": this.Data[item][9], "Tonco2": this.Data[item][4], "kwh_m2": this.Data[item][5], "m3_usr": this.Data[item][6], "Fecha": this.Data[item][10], "usd": this.Data[item][11], 'usd/m2': Math.round(((this.Data[item][11]/162) + Number.EPSILON) * 100) / 100 })
        }
      }      
      //actualizo tabla y graficas
      //this.actualizarTabla(this.originalQuery, this.falseQuery, this.OriginalBLQuery, this.false_last_month_original, this.false_last_month_predict);
      this.isloadingTable = true;
      this.sub.unsubscribe();
      this.updateOnetime();

    })

    let dateAlarms1 = new Date();
    dateAlarms1.setMonth(this.today.getMonth() - 12);
    let dummy = this.today;
    dummy.setDate(1);

    let start = [dateAlarms1.getFullYear().toString(), dateAlarms1.toString(), '01'].join('-');
    //fecha fin arreglo
    lastDayOfMonth = this.today;
    let end = [lastDayOfMonth.getFullYear().toString(), (lastDayOfMonth.getMonth()+1).toString(), lastDayOfMonth.getDate().toString()].join('-');
    

    this.alarmService.getAlarmsByTime(start, end).subscribe(result =>{
      //this.data = result;
      let data = [];
      let preproc = [];
      let devices = [];
      //copio los resultados a un objeto
      for(let alarm in result){
        preproc.push({'desc': result[alarm]['desc'], 'device': result[alarm]['device'], 'location': result[alarm]['office'], 'value': result[alarm]['value'], 'date': result[alarm]['timestamp']})
      }

      //forEach para rellenar las alarmas con sus respectivos valores 
      preproc.forEach(function (a) {
        if(!this[a.desc]){
          this[a.desc] = { desc: a.desc, devID: [], count: 0}
          data.push(this[a.desc])
        }
        if(this[a.desc]){
          this[a.desc].count += 1;
          let newD = true
          for(let name in this[a.desc].devID){
            if(this[a.desc].devID[name].name == a.device)
            {
              this[a.desc].devID[name].count += 1;
              newD = false;
            }
          }
          if(newD){
            this[a.desc].devID.push({name: a.device, count: 1});
            devices.push(a.device);
          }
          
        }

      }, Object.create(null));

      //con esto obtengo los nombres de los dispositivos que emitieron alertas sin repetirlos
      devices = devices.filter(function(item, pos) {
        return devices.indexOf(item) == pos;
      })

      //con esto creo la tabla y asigno respectivamente los valores necesarios
      let table = [['Descripcion']];
      for(let name in devices){table[0].push(devices[name])}
      let rowBuffer;
      for(let alarm in data){
        rowBuffer = [ data[alarm].desc ]
        for(let deviceName in data[alarm].devID){
          let Sname = data[alarm].devID[deviceName].name;
          for(let headerIndex in devices){
            if(rowBuffer.length <= devices.length){rowBuffer.push(0);}
            if(Sname == devices[headerIndex]){
              rowBuffer[parseInt(headerIndex)+1] = data[alarm].devID[deviceName].count;
            }
          }
        }
        table.push(rowBuffer);
      }
      console.log(table);
      if(table.length > 1)
      {
        this.TableMap.dataTable = table;
      }
      else
      {
        this.TableMap.dataTable = [['No Hay Datos']]
      }

      let cComponent = this.TableMap.component;
      let wrapper = cComponent.wrapper;

      cComponent.draw();
    })

    //Aqui consulta a BD por diarios
    let subdays = this.requestService.sendDailyConsumersRequest().subscribe(result => {

        
      this.falseQuery = []
      for(let item in result){
        if(result[item][3] == "OTROS")
        {
          this.falseQuery.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  'VARIOS', 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})  
        }
        else
        {
          this.falseQuery.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  result[item][3], 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})
        }
        
      }
      //this.actualizarTabla(this.originalQuery, this.falseQuery, this.OriginalBLQuery, this.false_last_month_original, this.false_last_month_predict);
      this.isloadingDays = true;
      subdays.unsubscribe();
      this.updateOnetime();
    })

    //Aqui consulta de consumidores mes anterior
    let lastConsums = this.requestService.sendConsumersRequest().subscribe(result =>{
      this.false_last_month_original = []
      for(let item in result){
        if(result[item][3] == "OTROS")
        {
          this.false_last_month_original.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  "VARIOS", 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})
        }
        else
        {
          this.false_last_month_original.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  result[item][3], 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})
        }
        
      }
      lastConsums.unsubscribe();
      this.LoadingLastConsumers = true;
      this.updateOnetime();

      // let osub = this.alarmService.getPredictData().subscribe(result =>{ 
      //   let places = []
      //   let proyections = []
      //   for(let i in result){
      //     for(let j in Object.keys(result[i])){
      //       places.push(Object.keys(result[i])[j]);
      //     }
      //   }
        
      //   for(let s in places){
      //     let consums = Object.keys(result[0][places[s]][0])
      //     for(let con in consums)
      //     {
      //       let dummy = places[s].split('_')
      //       proyections.push({'Zone': dummy[0], 'City': dummy[1], 'Sitio': dummy[2], 'consumidor': consums[con], 'kwh': result[0][places[s]][0][consums[con]][0], 'usd': result[0][places[s]][0][consums[con]][1]})
      //     }
      //   }
      //   this.Proyections = proyections;

      //   this.LoadingLastConsumers = true;
      //   this.updateOnetime();
      // })
      

    })

    //observer to get nots
    this.alarmService.getAlarmsRT().subscribe(result =>{
      this.Activealarms = result.length;
    });
    
    //observer to get view size 
    this.subObserver = this.observer.getMode().subscribe(result =>{
      this.isMobile = result.matches;
    })
  }

  updateOnetime(){
    if(this.isloadingDays && this.isloadingTable && this.Loadingsites && this.LoadingLastConsumers)
    {
      this.actualizarTabla(this.originalQuery, this.falseQuery, this.OriginalBLQuery, this.false_last_month_original, this.Proyections, this.otherData);
    };
  }

  @HostListener('window:resize', ['$event'])
  sizeChange($event){
    this.myNewDims = window.innerHeight - 45;
    this.myNewDims2 = window.innerHeight -87;

    let ccComponent = this.CompareBarsChart.component;
    let ccwrapper = ccComponent.wrapper;
    //redraw
    ccComponent.draw();

    ccComponent = this.MonthsUSDChart.component;
    ccwrapper = ccComponent.wrapper;
    //redraw
    ccComponent.draw();

    ccComponent = this.co2Chart.component;
    ccwrapper = ccComponent.wrapper;
    //redraw
    ccComponent.draw();

    ccComponent = this.KPI1Chart.component;
    ccwrapper = ccComponent.wrapper;
    //redraw
    ccComponent.draw();

    ccComponent = this.KPI2Chart.component;
    ccwrapper = ccComponent.wrapper;
    //redraw
    ccComponent.draw();

    ccComponent = this.KPI3Chart.component;
    ccwrapper = ccComponent.wrapper;
    //redraw
    ccComponent.draw();

    ccComponent = this.consumersChart.component;
    ccwrapper = ccComponent.wrapper;
    //redraw
    ccComponent.draw();

    console.log('redraw por cambio de dimensiones')
    // let ccComponent = this.dashboardPieChart.component;
    // let ccwrapper = ccComponent.wrapper;
    // ccComponent.draw();

    // this.currentChart.options.vAxis.baseline = '55'
    // let ccComponent2 = this.currentChart.component;
    // let ccwrapper2 = ccComponent.wrapper;

    // //redraw
    // ccComponent2.draw();
  }

  ngAfterViewInit(){
    this.findAdress();
  }

  listAttribs(index){
    let currentPlace = this.LevelTitle.replace(' / ', '-')
    currentPlace = currentPlace + '-' + index;
    for(let place in this.sites)
    {
      if(this.sites[place]["bd_id"] == currentPlace)
      {
        let id = this.sites[place]["index"];
        let epoch = parseInt(this.markers[id].Cat);
        let date = new Date(epoch *1000);
        this.devsTooltip= [date, this.markers[id].m2, this.markers[id].LineaB_kWh, this.markers[id].LineaB_diesel, this.markers[id].LineaB_Gas, this.markers[id].LineaB_Agua];
        
      }
    }
  }

  //get m2
  getm2FromList(id){
    id = id.replaceAll('/', '-');
    let m2;
    for(let i in this.sites){
      if(this.sites[i].bd_id == id){
        m2 = parseInt(this.sites[i].m2)
      }
    }
    return m2

  }
  //get users
  getUsersFromList(id){
    id = id.replaceAll('/', '-');
    let usr;
    for(let i in this.sites){
      if(this.sites[i].bd_id == id){
        usr = parseInt(this.sites[i].users)
      }
    }
    return usr
  }

  //--------------------------Filtros---------------------------------
  //primer nivel
  filterSelectors(){
    let date = new Date();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

    this.delay(50).then(any =>{
      this.midLevel = [];
      this.lastLevel = [];
      if(this.TopSelector.value == ''){ //si no hay nada seleccionado usara todo
        this.topLevel = Object.keys(this.tree);
        this.Nivel = "Nivel País"
        this.MidSelector.setValue('');
        this.LastSelector.setValue('');
        this.LastSelector.updateValueAndValidity();
        this.MidSelector.updateValueAndValidity();
        if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())
        {
          this.actualizarTabla(this.originalQuery, this.falseQuery, this.OriginalBLQuery, this.false_last_month_original, this.false_last_month_predict, this.otherData);
        }
        else
        {
          this.actualizarTabla(this.originalQuery, this.ParamsQueryDaily, this.OriginalBLQuery, this.ParamsQueryLastMonth, this.false_last_month_predict, this.otherData);
        }
        
      }
      else  //sino filtra
      {
        this.topLevel = this.TopSelector.value;
        this.Nivel = this.topLevel;
        this.filtrar2(this.topLevel);
      }
      
      //con esto relleno el selector del centro con las ciudades
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          this.midLevel.push(dummy[inds]);
        }
      }
      //con esto relleno el selector final con los sitios
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
          for(let last in dummy2)
          {
            this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
          }
        }
      }
      
    })
    
  }

  //Nivel medio
  filterMidSelectors(){
    this.delay(50).then(any =>{
      this.lastLevel = [];
      if(this.MidSelector.value == ''){
        
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
              this.Nivel = this.MidSelector.value;
            }
          }
        }
      }
      else
      {
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              if(this.MidSelector.value.includes(dummy[inds]))
                {
                  this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
                  this.Nivel = this.MidSelector.value;
                }
            }
          }
        }
      }
      this.LastSelector.setValue(this.lastLevel);
    })
  }

  //ultimo nivel
  filterLastSelector(){
    this.delay(50).then(any =>{
      if(this.LastSelector.value != '')
      {
        //console.log(this.LastSelector.value);
        let lastlvl = [];
        let top = [];
        let mid = [];
        for(let i in this.LastSelector.value){
          let dummy = this.LastSelector.value[i].id;
          dummy = dummy.split('/');
          lastlvl.push(this.LastSelector.value[i].name);                    
          mid.push(dummy[1]);
          top.push(dummy[0]);
        }
        this.filtrar(top, mid, lastlvl);
        for(let level in lastlvl)
        {
          if(lastlvl[level] == 'Inaquito')
          {
            lastlvl[level] = "Iñaquito"
          }
        }
        this.Nivel = lastlvl.join(' , ');
      }
      else
      {
        if(this.MidSelector.value != null)
        {
          this.Nivel = this.MidSelector.value
        }
        else
        {
          if(this.TopSelector.value != null)
          {
            this.Nivel = this.TopSelector.value;
          }
          else
          {
            this.Nivel = 'Nivel País'
          }
        }        
      }
      
    });

  }

  siteHasEnergy(index){
    let currentPlace = this.LevelTitle.replace(' / ', '-')
    currentPlace = currentPlace + '-' + index;
    for(let place in this.sites)
    {
      if(this.sites[place]["bd_id"] == currentPlace)
      {
        let id = this.sites[place]["index"];
        let pm = Object.keys(this.markers[id].devices);
        
        for (let index in pm){
          if (pm[index] == "PM"){
            return true
          }
        }
        
      }
    }
  }

  siteHasTemp(index){
    let currentPlace = this.LevelTitle.replace(' / ', '-')
    currentPlace = currentPlace + '-' + index;
    for(let place in this.sites)
    {
      if(this.sites[place]["bd_id"] == currentPlace)
      {
        let id = this.sites[place]["index"];
        let pm = Object.keys(this.markers[id].devices);
        
        for (let index in pm){
          if (pm[index] == "MT"){
            return true
          }
        }
        
      }
    }
  }

  siteHasAgua(index){
    let currentPlace = this.LevelTitle.replace(' / ', '-')
    currentPlace = currentPlace + '-' + index;
    for(let place in this.sites)
    {
      if(this.sites[place]["bd_id"] == currentPlace)
      {
        let id = this.sites[place]["index"];
        let pm = Object.keys(this.markers[id].devices);
        
        for (let index in pm){
          if (pm[index] == "Agua"){
            return true
          }
        }
        
      }
    }
  }

  siteHasGas(index){
    let currentPlace = this.LevelTitle.replace(' / ', '-')
    currentPlace = currentPlace + '-' + index;
    for(let place in this.sites)
    {
      if(this.sites[place]["bd_id"] == currentPlace)
      {
        let id = this.sites[place]["index"];
        let pm = Object.keys(this.markers[id].devices);
        
        for (let index in pm){
          if (pm[index] == "Gas"){
            return true
          }
        }
        
      }
    }
  }

  siteHasDiesel(index){
    let currentPlace = this.LevelTitle.replace(' / ', '-')
    currentPlace = currentPlace + '-' + index;
    for(let place in this.sites)
    {
      if(this.sites[place]["bd_id"] == currentPlace)
      {
        let id = this.sites[place]["index"];
        let pm = Object.keys(this.markers[id].devices);
        
        for (let index in pm){
          if (pm[index] == "Diesel"){
            return true
          }
        }
        
      }
    }
  }

  createTree(){
    //Para obtener divisiones del proyecto *arbol
    this.tree = {};
    for (let parts of this.sites)
    {
      var toplvl = parts.bd_id.split('-')[0];
      var medlvl = parts.bd_id.split('-')[1];
      var lowlvl = parts.bd_id.split('-')[2];
      this.addProps(this.tree, toplvl + "."+medlvl+"."+lowlvl, parts.bd_id);



    }
    
    var keys = Object.keys(this.tree);
    this.firstLvl = keys;
  }

  showmidLvl(parent){
    this.midLvlSelected = parent;
    this.midLvl = Object.keys(this.tree[parent]);
    this.LevelTitle = parent;
    this.filtrar(parent);
    this.currentLvl = this.currentLvl+1; 
  }

  showlastLvl(parent){
    this.lastLvlSelected = parent;
    this.lastLvl = Object.keys(this.tree[this.midLvlSelected][parent]);
    this.LevelTitle = this.LevelTitle.trim();
    this.LevelTitle = this.LevelTitle+" / "+parent;
    this.filtrar(this.midLvlSelected, parent);
    this.currentLvl = this.currentLvl+1; 
  }

  getlowlevels(parent){
    if (this.currentLvl == 1)
    {
      this.lastLvlTtip= Object.keys(this.tree[this.midLvlSelected][parent]);
    }
    else{
      this.lastLvlTtip= Object.keys(this.tree[parent]);
    }
    
  }

  showdevices(parent){
    this.siteLvlSelected = parent;
    this.filtrar(this.midLvlSelected, this.lastLvlSelected, parent);
    this.currentLvl = this.currentLvl+1;
    let currentPlace = this.LevelTitle.trim();
    currentPlace = this.LevelTitle.replace(' / ', '-');
    currentPlace = currentPlace+'-'+parent;
    this.LevelTitle = this.LevelTitle+" / "+parent;
    this.devsLvl = [];
    for(let place in this.sites)
    {
      if(this.sites[place]["bd_id"] == currentPlace)
      {

        let id = this.sites[place]["index"];
        let keys = Object.keys(this.markers[id].devices);
        let devs = this.markers[id].devices
        for(let names of keys)
        {
          let devtype = devs[names];
          for(let disps in devtype){
            this.devsLvl.push({"alias": devtype[disps].alias, "type": devtype[disps].type})
          }
        }
        
      }
    }

  }

  goback(){
    let dummy =  this.LevelTitle.split(' / ');
    let poped = dummy.pop();
    this.LevelTitle = dummy.join(' / ');
    this.currentLvl = this.currentLvl - 1;
    if(this.currentLvl == 0){
      this.actualizarTabla(this.originalQuery, this.falseQuery, this.OriginalBLQuery, this.false_last_month_original, this.false_last_month_predict, this.otherData);
    }
    if(this.currentLvl == 1){
      this.filtrar(this.midLvlSelected);
    }
    if(this.currentLvl == 2){
      this.filtrar(this.midLvlSelected, this.lastLvlSelected);
    }   
  }

  filterWidget(item, filter){
    item.label = filter.id;
    item.filter = filter;
    if(item.widgetType == 'Trendline')
    {
      this.delay(50).then(any =>{
        //console.log(this.LastSelector.value);
        let lastlvl = [];
        let top = [];
        let mid = [];
        let dummy = filter.id;
        dummy = dummy.split('/');
        lastlvl.push(filter.name);
        mid.push(dummy[1]);
        top.push(dummy[0]);
        let crit1 = top;let crit2 = mid;let crit3 = lastlvl;
        //ahora se filtra
        if(crit3.length >= 1)
        {
          let date = new Date();
          let month = (date.getMonth() + 1).toString();
          month = month.length > 1 ? month : '0' + month;
          let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

          if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.falseQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.false_last_month_original.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }
            //console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          else
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.ParamsQueryDaily.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.ParamsQueryLastMonth.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }

            console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          
        }
      });
    }
    if(item.widgetType == 'PieConsumers')
    {
      this.delay(50).then(any =>{
        //console.log(this.LastSelector.value);
        let lastlvl = [];
        let top = [];
        let mid = [];
        let dummy = filter.id;
        dummy = dummy.split('/');
        lastlvl.push(filter.name);
        mid.push(dummy[1]);
        top.push(dummy[0]);
        let crit1 = top;let crit2 = mid;let crit3 = lastlvl;
        //ahora se filtra
        if(crit3.length >= 1)
        {
          let date = new Date();
          let month = (date.getMonth() + 1).toString();
          month = month.length > 1 ? month : '0' + month;
          let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

          if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.falseQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.false_last_month_original.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }
            //console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          else
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.ParamsQueryDaily.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.ParamsQueryLastMonth.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }

            console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          
        }
      });
    }
    if(item.widgetType == 'KPI1')
    {
      this.delay(50).then(any =>{
        //console.log(this.LastSelector.value);
        let lastlvl = [];
        let top = [];
        let mid = [];
        let dummy = filter.id;
        dummy = dummy.split('/');
        lastlvl.push(filter.name);
        mid.push(dummy[1]);
        top.push(dummy[0]);
        let crit1 = top;let crit2 = mid;let crit3 = lastlvl;
        //ahora se filtra
        if(crit3.length >= 1)
        {
          let date = new Date();
          let month = (date.getMonth() + 1).toString();
          month = month.length > 1 ? month : '0' + month;
          let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

          if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.falseQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.false_last_month_original.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }
            //console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          else
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.ParamsQueryDaily.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.ParamsQueryLastMonth.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }

            console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          
        }
      });
    }
    if(item.widgetType == 'KPI2')
    {
      this.delay(50).then(any =>{
        //console.log(this.LastSelector.value);
        let lastlvl = [];
        let top = [];
        let mid = [];
        let dummy = filter.id;
        dummy = dummy.split('/');
        lastlvl.push(filter.name);
        mid.push(dummy[1]);
        top.push(dummy[0]);
        let crit1 = top;let crit2 = mid;let crit3 = lastlvl;
        //ahora se filtra
        if(crit3.length >= 1)
        {
          let date = new Date();
          let month = (date.getMonth() + 1).toString();
          month = month.length > 1 ? month : '0' + month;
          let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

          if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.falseQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.false_last_month_original.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }
            //console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          else
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.ParamsQueryDaily.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.ParamsQueryLastMonth.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }

            console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          
        }
      });
    }
    if(item.widgetType == 'KPI3')
    {
      this.delay(50).then(any =>{
        //console.log(this.LastSelector.value);
        let lastlvl = [];
        let top = [];
        let mid = [];
        let dummy = filter.id;
        dummy = dummy.split('/');
        lastlvl.push(filter.name);
        mid.push(dummy[1]);
        top.push(dummy[0]);
        let crit1 = top;let crit2 = mid;let crit3 = lastlvl;
        //ahora se filtra
        if(crit3.length >= 1)
        {
          let date = new Date();
          let month = (date.getMonth() + 1).toString();
          month = month.length > 1 ? month : '0' + month;
          let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

          if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.falseQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.false_last_month_original.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }
            //console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
          }
          else
          {
            let dummy = []
            let dummy2 = []
            let dummy3 = []
            let dummy4 = []
            let dummy5 = []
            let dummy6 = []
            for(let ind in crit3)
            {
              dummy = dummy.concat(this.originalQuery.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy2 = dummy2.concat(this.ParamsQueryDaily.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
                return criteria.site == crit3[ind]
              }))

              dummy4 = dummy4.concat(this.ParamsQueryLastMonth.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))

              dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
                return criteria.Sitio == crit3[ind]
              }))
            
            }

            console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
            this.actualizarWidget(dummy, dummy2, dummy3, dummy4, dummy5, dummy6, item.chart, item.widgetType);
            this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])

          }
          
        }
      });
    }

  }

  //funcion para crear el arbol desde BD
  addProps(obj, arr, val) {

    if (typeof arr == 'string')
        arr = arr.split(".");

    obj[arr[0]] = obj[arr[0]] || {};

    var tmpObj = obj[arr[0]];

    if (arr.length > 1) {
        arr.shift();
        this.addProps(tmpObj, arr, val);
    }
    else
        obj[arr[0]] = val;

    return obj;

  }

  filtrar(crit1, crit2:any = '0', crit3:any = '0'){
    if(crit3.length >= 1)
    {
      let date = new Date();
      let month = (date.getMonth() + 1).toString();
      month = month.length > 1 ? month : '0' + month;
      let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

      if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())
      {
        let dummy = []
        let dummy2 = []
        let dummy3 = []
        let dummy4 = []
        let dummy5 = []
        let dummy6 = []
        for(let ind in crit3)
        {
          dummy = dummy.concat(this.originalQuery.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy2 = dummy2.concat(this.falseQuery.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
            return criteria.site == crit3[ind]
          }))

          dummy4 = dummy4.concat(this.false_last_month_original.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))
        
        }
        //console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
        this.actualizarTabla(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
      }
      else
      {
        let dummy = []
        let dummy2 = []
        let dummy3 = []
        let dummy4 = []
        let dummy5 = []
        let dummy6 = []
        for(let ind in crit3)
        {
          dummy = dummy.concat(this.originalQuery.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy2 = dummy2.concat(this.ParamsQueryDaily.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy3 = dummy3.concat(this.OriginalBLQuery.filter(function(criteria){
            return criteria.site == crit3[ind]
          }))

          dummy4 = dummy4.concat(this.ParamsQueryLastMonth.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy5 = dummy5.concat(this.false_last_month_predict.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))

          dummy6 = dummy6.concat(this.otherData.filter(function(criteria){
            return criteria.Sitio == crit3[ind]
          }))
        
        }

        console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
        this.actualizarTabla(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);

      }
      
    }

    // let dummy = this.originalQuery.filter(function(criteria){
    //   if(crit2 != '0' && crit3 == '0') 
    //     {return criteria.Region == crit1 && criteria.Ciudad == crit2}
    //   if(crit2 != '0' && crit3 != '0') 
    //     {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
    //   return criteria.Region == crit1
    //   })
    // let dummy2 = this.falseQuery.filter(function(criteria){
    //   if(crit2 != '0' && crit3 == '0') 
    //     {return criteria.Region == crit1 && criteria.Ciudad == crit2}
    //   if(crit2 != '0' && crit3 != '0') 
    //     {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
    //   return criteria.Region == crit1
    //   })
    // let dummy3 = this.OriginalBLQuery.filter(function(criteria){
    //   if(crit2 != '0' && crit3 == '0') 
    //     {return criteria.zone == crit1 && criteria.city == crit2}
    //   if(crit2 != '0' && crit3 != '0') 
    //     {return criteria.zone == crit1 && criteria.city == crit2 && criteria.site == crit3 }
    //   return criteria.zone == crit1
    //   })
    // let dummy4 = this.false_last_month_original.filter(function(criteria){
    //   if(crit2 != '0' && crit3 == '0') 
    //     {return criteria.Region == crit1 && criteria.Ciudad == crit2}
    //   if(crit2 != '0' && crit3 != '0') 
    //     {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
    //   return criteria.Region == crit1
    //   })
    // let dummy5 = this.false_last_month_predict.filter(function(criteria){
    //   if(crit2 != '0' && crit3 == '0') 
    //     {return criteria.Zone == crit1 && criteria.City == crit2}
    //   if(crit2 != '0' && crit3 != '0') 
    //     {return criteria.Zone == crit1 && criteria.City == crit2 && criteria.Sitio == crit3 }
    //   return criteria.Zone == crit1
    //   })
    // let dummy6 = this.otherData.filter(function(criteria){
    //   if(crit2 != '0' && crit3 == '0') 
    //     {return criteria.Zone == crit1 && criteria.City == crit2}
    //   if(crit2 != '0' && crit3 != '0') 
    //     {return criteria.Zone == crit1 && criteria.City == crit2 && criteria.Sitio == crit3 }
    //   return criteria.Zone == crit1
    //   })
      
  }

  filtrar2(crit1, crit2:any = '0', crit3:any = '0'){
    
    let date = new Date();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);

    if(this.MonthdateControl.value.getDate() === lastDayOfMonth.getDate())  //Cuando es el mismo mes se filtran los valores ya en memoria
    {
      let dummy = this.originalQuery.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
        return criteria.Region == crit1
        })
      let dummy2 = this.falseQuery.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
        return criteria.Region == crit1
        })
      let dummy3 = this.OriginalBLQuery.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.zone == crit1 && criteria.city == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.zone == crit1 && criteria.city == crit2 && criteria.site == crit3 }
        return criteria.zone == crit1
        })
      let dummy4 = this.false_last_month_original.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
        return criteria.Region == crit1
        })
      let dummy5 = this.false_last_month_predict.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2 && criteria.Sitio == crit3 }
        return criteria.Zone == crit1
        })
      let dummy6 = this.otherData.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2 && criteria.Sitio == crit3 }
        return criteria.Zone == crit1
        })
      //console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
      this.actualizarTabla(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);

    }
    else  //cuando es otro mes se utiliza lo consultado
    {
      let dummy = this.originalQuery.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
        return criteria.Region == crit1
        })
      let dummy2 = this.ParamsQueryDaily.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
        return criteria.Region == crit1
        })
      let dummy3 = this.OriginalBLQuery.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.zone == crit1 && criteria.city == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.zone == crit1 && criteria.city == crit2 && criteria.site == crit3 }
        return criteria.zone == crit1
        })
      let dummy4 = this.ParamsQueryLastMonth.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Region == crit1 && criteria.Ciudad == crit2 && criteria.Sitio == crit3 }
        return criteria.Region == crit1
        })
      let dummy5 = this.false_last_month_predict.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2 && criteria.Sitio == crit3 }
        return criteria.Zone == crit1
        })
      let dummy6 = this.otherData.filter(function(criteria){
        if(crit2 != '0' && crit3 == '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2}
        if(crit2 != '0' && crit3 != '0') 
          {return criteria.Zone == crit1 && criteria.City == crit2 && criteria.Sitio == crit3 }
        return criteria.Zone == crit1
        })
      console.log(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
      this.actualizarTabla(dummy, dummy2, dummy3, dummy4, dummy5, dummy6);
    }

    
      
  }

  actualizarTabla(QueryData, FalseData, QueryBL, QueryLastM, QueryML, otherData){
    let kWhData = QueryData;
    let resultdata = []
    //this.animate();
    kWhData.forEach(function (a) {
      if (!this[a.Fecha]) {
          this[a.Fecha] = { Fecha: a.Fecha, kWh: 0, Diesel: 0, Gas: 0, Agua: 0, Tonco2: 0,  kwh_m2: 0, m3_usr: 0, usd: 0};
          resultdata.push(this[a.Fecha]);
      }
      this[a.Fecha].kWh += a.kWh;
      this[a.Fecha].kWh = (Math.round((this[a.Fecha].kWh + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Diesel += a.Diesel;
      this[a.Fecha].Diesel = (Math.round((this[a.Fecha].Diesel + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Gas += a.Gas;
      this[a.Fecha].Gas = (Math.round((this[a.Fecha].Gas + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Agua += a.Agua;
      this[a.Fecha].Agua = (Math.round((this[a.Fecha].Agua + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Tonco2 += a.Tonco2;
      this[a.Fecha].Tonco2 = (Math.round((this[a.Fecha].Tonco2 + Number.EPSILON) * 100) / 100);
      this[a.Fecha].kwh_m2 += a.kwh_m2;
      this[a.Fecha].kwh_m2 = (Math.round((this[a.Fecha].kwh_m2 + Number.EPSILON) * 100) / 100);
      this[a.Fecha].m3_usr += a.m3_usr;
      this[a.Fecha].m3_usr = (Math.round((this[a.Fecha].m3_usr + Number.EPSILON) * 100) / 100);
      this[a.Fecha].usd += a.usd;
      this[a.Fecha].usd = (Math.round((this[a.Fecha].usd + Number.EPSILON) * 100) / 100);
      
  }, Object.create(null));

  //actualizo los valores en tabla
  for(let values in resultdata){
    this.Electr[values] = resultdata[values].kWh;
    this.Electr_usd[values] = resultdata[values].usd;
    this.Gas[values] = resultdata[values].Gas;
    this.Agua[values] = resultdata[values].Agua;
    //this.Tonco2[values] = resultdata[values].Tonco2 ;
    this.kwhm2[values] = resultdata[values].kwh_m2;
    this.m3_usr[values] = resultdata[values].m3_usr;
    this.totalkwh[values] = resultdata[values].kWh + (resultdata[values].Diesel*39.75) + (resultdata[values].Gas*12.6389);
    this.totalkwh[values] = (Math.round((this.totalkwh[values] + Number.EPSILON) * 100) / 100);
    this.Tonco2[values] = this.totalkwh[values] * 0.000266;
    this.Tonco2[values] =  (Math.round((this.Tonco2[values] + Number.EPSILON) * 100) / 100);
  }

    //aqui actualizo los PROMEDIOS en tabla
    //electricidad
    this.PromElectr = 0;
    for(let i in this.Electr){
      this.PromElectr += this.Electr[i];   
    } 
    this.PromElectr =  Math.round(((this.PromElectr / this.Electr.length) + Number.EPSILON) * 100) / 100;
    //electricidad USD
    this.PromElectrUSD = 0;
    for(let i in this.Electr_usd){
      this.PromElectrUSD += this.Electr_usd[i];   
    } 
    this.PromElectrUSD =  Math.round(((this.PromElectrUSD / this.Electr_usd.length) + Number.EPSILON) * 100) / 100;
    console.log(this.Electr_usd)

    //se arman las lineas base - Ahora con tarifas
    let sitespreproc = QueryBL
    let newarray = [];
    sitespreproc.forEach(function (a) {
      if (!this[a.bd_id]) {
          this[a.bd_id] = { zone: a.zone, city: a.city, site: a.site, BL_elec: a.BL_elec, BL_diesel: a.BL_diesel, BL_gas: a.BL_gas, BL_agua: a.BL_agua, bd_id: a.bd_id};
          newarray.push(this[a.bd_id]);
      }
      this[a.bd_id].BL_elec = a.BL_elec * a.tarifa_kwh;
      this[a.bd_id].BL_elec = (Math.round((this[a.bd_id].BL_elec + Number.EPSILON) * 100) / 100);
      this[a.bd_id].BL_diesel = a.BL_diesel * a.tarifa_diesel;
      this[a.bd_id].BL_diesel = (Math.round((this[a.bd_id].BL_diesel + Number.EPSILON) * 100) / 100);
      this[a.bd_id].BL_gas = a.BL_gas * a.tarifa_gas;
      this[a.bd_id].BL_gas = (Math.round((this[a.bd_id].BL_gas + Number.EPSILON) * 100) / 100);
      this[a.bd_id].BL_agua = a.BL_agua * a.tarifa_agua;
      this[a.bd_id].BL_agua = (Math.round((this[a.bd_id].BL_agua + Number.EPSILON) * 100) / 100);

    }, Object.create(null));
    

    this.Blines = newarray;
    this.BL_kWh = 0;
    this.BL_Diesel = 0;
    this.BL_Gas = 0;
    this.BL_Agua = 0;

    for(let s in this.Blines){
      this.BL_kWh = (Math.round(((this.BL_kWh + this.Blines[s].BL_elec) + Number.EPSILON) * 100) / 100);
      this.BL_Diesel = (Math.round(((this.BL_Diesel + this.Blines[s].BL_diesel) + Number.EPSILON) * 100) / 100);
      this.BL_Gas = (Math.round(((this.BL_Gas + this.Blines[s].BL_gas) + Number.EPSILON) * 100) / 100);
      this.BL_Agua = (Math.round(((this.BL_Agua + this.Blines[s].BL_agua) + Number.EPSILON) * 100) / 100);
    }
    // console.log('Elec', this.BL_kWh)
    // console.log('Diesel', this.BL_Diesel)
    // console.log('Gas', this.BL_Gas)
    // console.log('Agua', this.BL_Agua)

    //Actualizo graficos y LineasBase
    this.MonthsUSDChart.options.vAxis.baseline = (this.BL_kWh/1000).toString();
    this.MonthsUSDChart.dataTable = [
      ['M-A', 'CONSUMO (USD)', 'Linea Base (USD)'],
      [this.Months[0],  this.Electr_usd[0] , this.BL_kWh],
      [this.Months[1],  this.Electr_usd[1] , this.BL_kWh],
      [this.Months[2],  this.Electr_usd[2] , this.BL_kWh],
      [this.Months[3],  this.Electr_usd[3] , this.BL_kWh],
      [this.Months[4],  this.Electr_usd[4] , this.BL_kWh],
      [this.Months[5],  this.Electr_usd[5] , this.BL_kWh],
      [this.Months[6],  this.Electr_usd[6] , this.BL_kWh],
      [this.Months[7],  this.Electr_usd[7] , this.BL_kWh],
      [this.Months[8],  this.Electr_usd[8] , this.BL_kWh],
      [this.Months[9],  this.Electr_usd[9] , this.BL_kWh],
      [this.Months[10],  this.Electr_usd[10] , this.BL_kWh],
      [this.Months[11],  this.Electr_usd[11] , this.BL_kWh],
    ];

    let t2RowsNew = [];
    let tonnsNew: any = [['M-A', 'Ton CO2']];
    let kpi1New: any = [['M-A', 'KPI Consumo/Ventas (%)' ]];
    let kpi2New: any = [['M-A', 'KPI Consumo/Area (USD/m2)' ]];
    let kpi3New: any = [['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ]];
    let ventas = [];
    this.Diesel = [];
    this.Gas = [];
    this.Savings = [];

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////Separador de cirugia inicia////////////////////////////////////////////////////////////

    let consolidateMonths = [];
    let consolidateTonCO2 = [];
    let consolidateKPI1 = [];
    let consolidateKPI2 = [];
    let consolidateKPI3 = [];
    
    for(let month in this.Months)
    {
      let findMonth = false;
      let realMonth = this.transformMonth(this.Months[month])
      for(let data in kWhData)
      {
        let dataMonth = kWhData[data]['Fecha'].split('-')[1];
        if(realMonth == dataMonth)
        {
          findMonth = true
          for(let odata in otherData)
          {
            let oDate = new Date(otherData[odata]['date']).getMonth()
            oDate += 1;
            let id = kWhData[data]['Region'] + '-' + kWhData[data]['Ciudad'] + '-' + kWhData[data]['Sitio']
            if(realMonth == oDate && otherData[odata]['place'] == id)
            {
              let dieselTransf = 0;
              let gasTransf = 0;
              let Rbuffer = consolidateMonths[month];        
              //Agrego a los datos
              if(Rbuffer != undefined)
              {
                let bufferUSD = Rbuffer['consumousd']
                let bufferSavings = Rbuffer['ahorrousd']
                let bufferKWH = Rbuffer['electricidadkwh']
                let bufferDIESEL = Rbuffer['dieselgal']
                let bufferGAS = Rbuffer['gasm3']
                let bufferENERGY = Rbuffer['consumoenergia']
                let bufferCO2 = Rbuffer['emisionestonco2']
                let bufferSALES = Rbuffer['ventasusd']
                let bufferKPI1 = Rbuffer['KPI1']
                let bufferKPI2 = Rbuffer['KPI2']
                let bufferKPI3 = Rbuffer['KPI3']
                if(otherData[odata]['sales'] != 0)
                {
                  ventas[month] = ventas[month] + parseInt(otherData[odata]['sales']);
                  bufferKPI1 = bufferKPI1 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + (otherData[odata]['gas']*12.6389)*0.1 )/ otherData[odata]['sales']);
                }
                if(otherData[odata]['diesel'] != '0')
                  {this.Diesel[month] = this.Diesel[month] + parseFloat(otherData[odata]['diesel']); dieselTransf=(otherData[odata]['diesel']*39.75)*1  }else{dieselTransf = 0;}
                if(otherData[odata]['gas'] != '0')
                  {this.Gas[month] = this.Gas[month] + parseFloat(otherData[odata]['gas']); gasTransf = (otherData[odata]['gas']*12.6389)*0.1}else{gasTransf = 0}
                bufferUSD = bufferUSD + kWhData[data]['usd'];
                bufferSavings = bufferSavings + kWhData[data]['usd']//(this.BL_kWh - kWhData[data]['usd']);
                bufferKWH = bufferKWH + kWhData[data]['kWh']
                bufferDIESEL = bufferDIESEL + parseFloat(otherData[odata]['diesel']);
                bufferGAS = bufferGAS + parseFloat(otherData[odata]['gas']);
                bufferENERGY = bufferENERGY + (kWhData[data]['kWh'] + otherData[odata]['diesel']*39.75 + otherData[odata]['gas']*12.6389);
                bufferCO2 = bufferCO2 + kWhData[data]['Tonco2'];
                bufferSALES = bufferSALES + parseFloat(otherData[odata]['sales']);
                bufferKPI2 = bufferKPI2 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1 )+ ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2']);
                bufferKPI3 = bufferKPI3 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) ) / otherData[odata]['users']);
                bufferSavings = this.BL_kWh - bufferUSD;
                consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': bufferUSD, 'ahorrousd': bufferSavings, 'electricidadkwh': bufferKWH, "dieselgal": bufferDIESEL, "gasm3": bufferGAS, "consumoenergia": bufferENERGY, 'emisionestonco2': bufferCO2, 'ventasusd': bufferSALES, 'KPI1': bufferKPI1, 'KPI2': bufferKPI2, 'KPI3': bufferKPI3}
              }
              else
              {
                if(otherData[odata]['diesel'] != '0')
                  {this.Diesel[month] = parseFloat(otherData[odata]['diesel']); dieselTransf=(otherData[odata]['diesel']*39.75)*1  }else{dieselTransf = 0;}
                if(otherData[odata]['gas'] != '0')
                  {this.Gas[month] = parseFloat(otherData[odata]['gas']); gasTransf = (otherData[odata]['gas']*12.6389)*0.1}else{gasTransf = 0}
                if(otherData[odata]['sales'] != 0)
                {
                  ventas[month] = parseInt(otherData[odata]['sales']);
                  consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': kWhData[data]['usd'], 'ahorrousd': this.BL_kWh - kWhData[data]['usd'], 'electricidadkwh': kWhData[data]['kWh'], "dieselgal": parseFloat(otherData[odata]['diesel']) , "gasm3": parseFloat(otherData[odata]['gas']), "consumoenergia": kWhData[data]['kWh'] + otherData[odata]['diesel']*39.75 + otherData[odata]['gas']*12.6389, 'emisionestonco2': kWhData[data]['Tonco2'] + (((otherData[odata]['diesel']*39.75) + (otherData[odata]['gas']*12.6389))*0.000266), 'ventasusd': parseFloat(otherData[odata]['sales']), 'KPI1': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + (otherData[odata]['gas']*12.6389)*0.1 )/ otherData[odata]['sales'], 'KPI2': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1 )+ ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2'], 'KPI3':(kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) ) / otherData[odata]['users']}
                }
                else
                {
                  consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': kWhData[data]['usd'], 'ahorrousd': this.BL_kWh - kWhData[data]['usd'], 'electricidadkwh': kWhData[data]['kWh'], "dieselgal": parseFloat(otherData[odata]['diesel']) , "gasm3": parseFloat(otherData[odata]['gas']), "consumoenergia": kWhData[data]['kWh'] + otherData[odata]['diesel']*39.75 + otherData[odata]['gas']*12.6389, 'emisionestonco2': kWhData[data]['Tonco2']+ (((otherData[odata]['diesel']*39.75) + (otherData[odata]['gas']*12.6389))*0.000266), 'ventasusd': parseFloat(otherData[odata]['sales']), 'KPI1': 0, 'KPI2': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1 )+ ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2'], 'KPI3':(kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) ) / otherData[odata]['users']}
                }
              }  
              //console.log(consolidateMonths);
              //Agrego a TonCO2
              let TonBuffer= consolidateTonCO2[month];       
              if( TonBuffer != undefined)
              {
                let lastTon = consolidateTonCO2[month]['Tons'];
                lastTon = lastTon + kWhData[data]['Tonco2'];
                consolidateTonCO2[month] = {"Mes": this.Months[month], 'Tons': lastTon}
              }
              else
              {
                consolidateTonCO2[month] = {"Mes": this.Months[month], 'Tons': kWhData[data]['Tonco2']+ (((otherData[odata]['diesel']*39.75) + (otherData[odata]['gas']*12.6389))*0.000266)}
              }
              //Agrego KPI1
              let kpi1Buffer = consolidateKPI1[month]
              if( kpi1Buffer != undefined)
              {
                if(otherData[odata]['sales'] != 0)
                {
                  let lastKPI1 = consolidateKPI1[month]['kpi1']
                  lastKPI1 = lastKPI1 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['sales'] );
                  consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': lastKPI1 }
                }
              }
              else
              {
                if(otherData[odata]['sales'] != 0)
                {
                  consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['sales']  }
                }
                else
                {
                  consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': 0 }
                }
              }
              //Agrego KPI2
              let kpi2Buffer = consolidateKPI2[month]
              if( kpi2Buffer != undefined)
              {
                let lastkpi2 = consolidateKPI2[month]['kpi2']
                lastkpi2 = lastkpi2 + ((kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2']);
                consolidateKPI2[month] = {"Mes": this.Months[month], 'kpi2': lastkpi2}
              }
              else
              {
                consolidateKPI2[month] = {"Mes": this.Months[month], 'kpi2': (kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2']}
              }
              //Agrego KPI3
              let kpi3Buffer = consolidateKPI3[month]
              if( kpi3Buffer != undefined)
              {
                let lastkpi3 = consolidateKPI3[month]['kpi3']
                lastkpi3 = lastkpi3 + ( (kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['users']);
                consolidateKPI3[month] = {"Mes": this.Months[month], 'kpi3': lastkpi3 };
              }
              else
              {
                consolidateKPI3[month] = {"Mes": this.Months[month], 'kpi3': (kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['users'] };
              }
            }
          }
        }        
      }
      if(!findMonth)
      {
        consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0}
        consolidateTonCO2[month] = {"Mes": this.Months[month], 'Tons': null};
        consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': null};
        consolidateKPI2[month] = {"Mes": this.Months[month], 'kpi2': null};
        consolidateKPI3[month] = {"Mes": this.Months[month], 'kpi3': null};
      }
    }
    
    tonnsNew = [['M-A', 'Ton CO2']];    
    let legend = []
    for(let ton in consolidateTonCO2)
    {
      tonnsNew.push([ {v: parseInt(ton), f: consolidateTonCO2[ton]['Mes']}, consolidateTonCO2[ton]['Tons'] ]);
      legend.push({v: parseInt(ton), f: consolidateTonCO2[ton]['Mes']})
    }
    this.co2Chart.options.hAxis.ticks = legend;
    
    kpi1New = [['M-A', 'KPI Consumo/Ventas (%)' ]];
    for(let kpi in consolidateKPI1)
    {
      kpi1New.push([consolidateKPI1[kpi]['Mes'], consolidateKPI1[kpi]['kpi1']]);
      if(consolidateKPI1[kpi]['kpi1'] != null)
      {
        this.KPI1_list.push(consolidateKPI1[kpi]['kpi1']);
      }
    }
    this.KPI1Chart.options.hAxis.ticks = legend;

    kpi2New = [['M-A', 'KPI Consumo/Area (USD/m2)' ]];
    for(let kpi in consolidateKPI2)
    {
      kpi2New.push([ {v: parseInt(kpi), f: consolidateKPI2[kpi]['Mes'] }, consolidateKPI2[kpi]['kpi2']]);
      if(consolidateKPI2[kpi]['kpi2'] != null)
      {
        this.KPI2_list.push(consolidateKPI2[kpi]['kpi2']);
      }
    }
    this.KPI2Chart.options.hAxis.ticks = legend;

    kpi3New = [['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ]];
    for(let kpi in consolidateKPI3)
    {
      kpi3New.push([ {v: parseInt(kpi), f: consolidateKPI3[kpi]['Mes'] }, consolidateKPI3[kpi]['kpi3']]);
      if(consolidateKPI3[kpi]['kpi3'] != null)
      {
        this.KPI3_list.push(consolidateKPI3[kpi]['kpi3']);
      }
    }
    this.KPI3Chart.options.hAxis.ticks = legend;

    t2RowsNew = [];
    for(let value in consolidateMonths)
    {
      t2RowsNew.push(consolidateMonths[value])
      if(consolidateMonths[value]['ahorrousd'] != 0)
        {this.Savings.push(consolidateMonths[value]['ahorrousd']);}
    }



    
    ////////////////////////////////Separador de cirugia termina////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //genero promedio de ahorros y KPI
    //Prom tonco2
    this.PromTonco2 = 0;
    let len = 0;
    for(let i in consolidateTonCO2)
    {
      if(consolidateTonCO2[i]['Tons'] != null){len += 1;};
      this.PromTonco2 += consolidateTonCO2[i]['Tons'];
    }
    this.PromTonco2 = Math.round(((this.PromTonco2 / len) + Number.EPSILON) * 100) / 100; 
    //Prom totalkwh
    this.Promtotalkwh = 0;
    let len2 = 0;
    for(let i in consolidateMonths)
    {
      this.Promtotalkwh += consolidateMonths[i]['consumoenergia'];
    }
    this.Promtotalkwh = Math.round(((this.Promtotalkwh / len) + Number.EPSILON) * 100) / 100; 
    //Prom Diesel
    let filteredDiesel = ventas.filter(function (el) {
      return el != null;
    });
    this.PromDiesel = 0;
    for(let i in filteredDiesel)
    {
      this.PromDiesel += parseInt(filteredDiesel[i]);
    }
    this.PromDiesel = Math.round(((this.PromDiesel / filteredDiesel.length) + Number.EPSILON) * 100) / 100; 
    //Prom Gas
    let filteredGas = ventas.filter(function (el) {
      return el != null;
    });
    this.PromGas = 0;
    for(let i in filteredGas)
    {
      this.PromGas += parseInt(filteredGas[i]);
    }
    this.PromGas = Math.round(((this.PromGas / filteredGas.length) + Number.EPSILON) * 100) / 100; 
    //ventas prom
    let filtered = ventas.filter(function (el) {
      return el != null;
    });
    this.PromSales = 0;
    for(let i in filtered){
      this.PromSales += parseInt(filtered[i]);   
    } 
    this.PromSales =  Math.round(((this.PromSales / filtered.length) + Number.EPSILON) * 100) / 100; 
    //ahorro USD
    this.PromUSDSavings = 0;
    for(let i in this.Savings){
      this.PromUSDSavings += this.Savings[i];   
    } 
    this.PromUSDSavings =  Math.round(((this.PromUSDSavings / this.Savings.length) + Number.EPSILON) * 100) / 100;
    // KPI1
    this.PromKPI1 = 0;
    for(let i in this.KPI1_list){
      this.PromKPI1 += this.KPI1_list[i];   
    } 
    this.PromKPI1 =  Math.round(((this.PromKPI1 / this.KPI1_list.length) + Number.EPSILON) * 100) / 100;
    // KPI2
    this.PromKPI2 = 0;
    for(let i in this.KPI2_list){
      this.PromKPI2 += this.KPI2_list[i];   
    } 
    this.PromKPI2 =  Math.round(((this.PromKPI2 / this.KPI2_list.length) + Number.EPSILON) * 100) / 100;
    // KPI3
    this.PromKPI3 = 0;
    for(let i in this.KPI3_list){
      this.PromKPI3 += this.KPI3_list[i];   
    } 
    this.PromKPI3 =  Math.round(((this.PromKPI3 / this.KPI3_list.length) + Number.EPSILON) * 100) / 100;

    //actualizo los valores de la tabla #2 
    this.t2rows = t2RowsNew;
    //Actualizo las graficas finales
    if(tonnsNew.length == 1)
    {
      tonnsNew.push(['', 0]);
    }
    this.co2Chart.dataTable = tonnsNew;
    if(kpi1New.length == 1)
    {
      kpi1New.push(['', 0]);
    }
    if(kpi2New.length == 1)
    {
      kpi2New.push(['', 0]);
    }
    if(kpi3New.length == 1)
    {
      kpi3New.push(['', 0]);
    }
    this.KPI1Chart.dataTable = kpi1New;
    this.KPI2Chart.dataTable = kpi2New;
    this.KPI3Chart.dataTable = kpi3New;

    //actualizo los valores mensuales y promedio a fecha
    //obtener mes actual para comparar
    let todatedatafull = FalseData;
    let todateprocessed = [];
    let todateProyect = [];
    let todateProyectprocessed = [];
    let lastMprocessed = [];
    let filteredRows = [];
    let monthsCount = 0;


    let dummy = this.MonthdateControl.value;
    let fd = new Date(dummy.getFullYear(), dummy.getMonth(), 1),
        month = '' + (fd.getMonth() + 1),
        day = '' + fd.getDate(),
        year = fd.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    //obtengo ultimo dia del mes anterior
    let startDate = [year, month, day].join('-');
    todatedatafull = FalseData.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= new Date(startDate);
    });
    
    //obtengo ultimo dia del mes anterior proyeccion aritmetica
    todateProyect = FalseData.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= new Date(startDate);
    });

    if(todatedatafull.length == 0){ //si es el primer dia y no hay datos no lleno valores.
      for(let consumer in this.consumersNames){
        todateprocessed.push({ consumidor: this.consumersNames[consumer], kwh: 0, usd: 0});
      }
    }else{ //si ya hay datos relleno valores
      todatedatafull.forEach(function (a) {
      if (!this[a.consumidor]) {
          this[a.consumidor] = { consumidor: a.consumidor, kwh: 0, usd: 0};
          todateprocessed.push(this[a.consumidor]);
          monthsCount += 1;
      }      
      this[a.consumidor].kwh += a.valor;
      this[a.consumidor].kwh = (Math.round((this[a.consumidor].kwh + Number.EPSILON) * 100) / 100);
      this[a.consumidor].usd += a.valor_usd;
      this[a.consumidor].usd = (Math.round((this[a.consumidor].usd + Number.EPSILON) * 100) / 100);
      }, Object.create(null));      
    }

    if(todateProyect.length == 0){
      for(let consumer in this.consumersNames){
        todateProyect.push({ consumidor: this.consumersNames[consumer], kwh: 0, usd: 0});
      }
    }else{//aqui lleno los valores de proyeccion aritmetica
      todateProyect.forEach(function (a) {
        if (!this[a.consumidor]) {
            this[a.consumidor] = { consumidor: a.consumidor, kwh: 0, usd: 0};
            todateProyectprocessed.push(this[a.consumidor]);
            //monthsCount += 1;
        }
        
        this[a.consumidor].kwh += a.valor;
        this[a.consumidor].kwh = (Math.round((this[a.consumidor].kwh + Number.EPSILON) * 100) / 100);
        this[a.consumidor].usd += a.valor_usd;
        this[a.consumidor].usd = (Math.round((this[a.consumidor].usd + Number.EPSILON) * 100) / 100);
        }, Object.create(null));
    }
    todateprocessed.sort(this.dynamicSort('consumidor')); 
    todateProyectprocessed.sort(this.dynamicSort('consumidor')); 

    //obtiene los dias faltantes en el mes corriendo
    var getRemanningDays = function () {
      var date = new Date();
      var time = new Date(date.getTime());
      time.setMonth(date.getMonth() + 1);
      time.setDate(0);
      return(time.getDate() > date.getDate() ? time.getDate() - date.getDate() : 0);
    }
    let remainingDays = getRemanningDays() + 1;
    let currentDays = new Date().getDate() - 1;
    if(!this.LookingCurrentMonth){
      remainingDays = 0;
    }

    if(remainingDays != 0){
      for(let x in todateProyectprocessed)
      {
        todateProyectprocessed[x].kwh = ((todateProyectprocessed[x].kwh / currentDays)*remainingDays)+todateProyectprocessed[x].kwh;
        todateProyectprocessed[x].usd = ((todateProyectprocessed[x].usd / currentDays)*remainingDays)+todateProyectprocessed[x].usd;
      }
    }

    this.monthTodateTotal_Energy = 0;
    this.monthTodateTotal_Diesel = 0;
    this.monthTodateTotal_Gas = 0;
    this.monthTodateTotal_Agua = 0;
    this.monthTodateProm_Energy = 0;
    this.monthTodateProm_Diesel = 0;
    this.monthTodateProm_Gas = 0;
    this.monthTodateProm_Agua = 0;

    for(let i in todateprocessed){
        this.monthTodateTotal_Energy += todateprocessed[i].kWh;
        this.monthTodateTotal_Diesel += todateprocessed[i].Diesel;
        this.monthTodateTotal_Gas += todateprocessed[i].Gas;
        this.monthTodateTotal_Agua += todateprocessed[i].Agua;
      }
    ///////////////////////////////////Obtener valores diarios mes anterior
      let fs = new Date(),
          monthl = '' + (fs.getMonth()),
          dayl = '' + fs.getDate(),
          yearl = fs.getFullYear();

      if (monthl.length < 2) 
          monthl = '0' + monthl;
      if (day.length < 2) 
          dayl = '0' + dayl;

      let endDate = [yearl, monthl, dayl].join('-');
      let lasttodatedatafull = [];
      // lasttodatedatafull = QueryLastM.filter(function(a){
      //   let aDate = new Date(a.Fecha);
      //   return aDate < new Date(endDate);
      // });
      lasttodatedatafull = QueryLastM;

      lasttodatedatafull.forEach(function (a) {
        if (!this[a.consumidor]) {
            this[a.consumidor] = { consumidor: a.consumidor, kwh4: 0, usd4: 0};
            lastMprocessed.push(this[a.consumidor]);
        }
        
        this[a.consumidor].kwh4 += a.valor;
        this[a.consumidor].kwh4 = (Math.round((this[a.consumidor].kwh4 + Number.EPSILON) * 100) / 100);
        this[a.consumidor].usd4 += a.valor_usd;
        this[a.consumidor].usd4 = (Math.round((this[a.consumidor].usd4 + Number.EPSILON) * 100) / 100);
    }, Object.create(null));
    lastMprocessed.sort(this.dynamicSort('consumidor'));

    //QueryML = this.Proyections;
    QueryML = todateProyectprocessed;
    if(QueryML == '')
    {
      for(let consumer in this.consumersNames){
        QueryML.push({ consumidor: this.consumersNames[consumer], kwh: 0, usd: 0});
      }
    }
    QueryML.sort(this.dynamicSort('site'));
    console.log(todateprocessed);
    // for(let consum in todateprocessed){
    //   filteredRows[consum] = {consumidor: todateprocessed[consum].consumidor, kwh: todateprocessed[consum].kwh, usd: todateprocessed[consum].usd, kwh2: QueryML[consum].kwh, usd2: QueryML[consum].usd, kwh3: 0, usd3: 0, index1: 'neut', kwh4: lastMprocessed[consum].kwh4, usd4: lastMprocessed[consum].usd4, index2: 'neut' }
    //   if(filteredRows[consum].kwh2 < filteredRows[consum].kwh3 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index1 = 'inc'};
    //   if(filteredRows[consum].kwh2 > filteredRows[consum].kwh3 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index1 = 'dec'};
    //   if(filteredRows[consum].kwh2 == filteredRows[consum].kwh3 || filteredRows[consum].kwh2 == 0 || filteredRows[consum].kwh3 == 0){filteredRows[consum].index1 = 'neut'}
    //   if(filteredRows[consum].kwh2 > filteredRows[consum].kwh4 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index2 = 'inc'};
    //   if(filteredRows[consum].kwh2 < filteredRows[consum].kwh4 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index2 = 'dec'};
    //   if(filteredRows[consum].kwh2 == filteredRows[consum].kwh4 || filteredRows[consum].kwh2 == 0){filteredRows[consum].index2 = 'neut'}
    // }
    for (let consum in todateprocessed) {
      const todate = todateprocessed[consum];
      const query = typeof QueryML === 'object' && QueryML[consum] ? QueryML[consum] : { kwh: 0, usd: 0 };
      const lastM = typeof lastMprocessed === 'object' && lastMprocessed[consum] ? lastMprocessed[consum] : { kwh4: 0, usd4: 0 };
    
      filteredRows[consum] = {
        consumidor: todate.consumidor,
        kwh: todate.kwh,
        usd: todate.usd,
        kwh2: query.kwh,
        usd2: query.usd,
        kwh3: 0,
        usd3: 0,
        index1: 'neut',
        kwh4: lastM.kwh4,
        usd4: lastM.usd4,
        index2: 'neut'
      };
    
      if (filteredRows[consum].kwh2 < filteredRows[consum].kwh3 && filteredRows[consum].kwh2 !== 0) {
        filteredRows[consum].index1 = 'inc';
      } else if (filteredRows[consum].kwh2 > filteredRows[consum].kwh3 && filteredRows[consum].kwh2 !== 0) {
        filteredRows[consum].index1 = 'dec';
      } else {
        filteredRows[consum].index1 = 'neut';
      }
    
      if (filteredRows[consum].kwh2 > filteredRows[consum].kwh4 && filteredRows[consum].kwh2 !== 0) {
        filteredRows[consum].index2 = 'inc';
      } else if (filteredRows[consum].kwh2 < filteredRows[consum].kwh4 && filteredRows[consum].kwh2 !== 0) {
        filteredRows[consum].index2 = 'dec';
      } else {
        filteredRows[consum].index2 = 'neut';
      }
    }

    //se suman todos los consumidores para totales
    let totals = {totalkwh: 0, totalusd: 0, totalkwh2: 0, totalusd2: 0, totalkwh3: 0, totalusd3: 0, totalindex1: 'und', totalkwh4: 0, totalusd4: 0, totalindex2: 'und'};
    for(let cons in filteredRows){
      totals.totalkwh += filteredRows[cons].kwh
      totals.totalkwh =  (Math.round((totals.totalkwh + Number.EPSILON) * 100) / 100);
      totals.totalusd += filteredRows[cons].usd
      totals.totalusd =  (Math.round((totals.totalusd + Number.EPSILON) * 100) / 100);
      
      totals.totalkwh2 += filteredRows[cons].kwh2
      totals.totalkwh2 =  (Math.round((totals.totalkwh2 + Number.EPSILON) * 100) / 100);
      totals.totalusd2 += filteredRows[cons].usd2
      totals.totalusd2 =  (Math.round((totals.totalusd2 + Number.EPSILON) * 100) / 100);
      
      totals.totalkwh3 += filteredRows[cons].kwh3
      totals.totalkwh3 =  (Math.round((totals.totalkwh3 + Number.EPSILON) * 100) / 100);
      totals.totalusd3 += filteredRows[cons].usd3
      totals.totalusd3 =  (Math.round((totals.totalusd3 + Number.EPSILON) * 100) / 100);
      
      totals.totalkwh4 += filteredRows[cons].kwh4
      totals.totalkwh4 =  (Math.round((totals.totalkwh4 + Number.EPSILON) * 100) / 100);
      totals.totalusd4 += filteredRows[cons].usd4
      totals.totalusd4 =  (Math.round((totals.totalusd4 + Number.EPSILON) * 100) / 100);
    }
    //se asignan los totales a los parametros globales para tabla
    this.TotalCurrentkwh = totals.totalkwh;
    this.TotalCurrentusd = totals.totalusd;
    this.TotalProykwh = totals.totalkwh2;
    this.TotalProyusd = totals.totalusd2;
    this.TotalLastYrkwh = totals.totalkwh3;
    this.TotalLastYrusd = totals.totalusd3;
    this.TotalLastMnthkwh = totals.totalkwh4;
    this.TotalLastMnthusd = totals.totalusd4;

    this.rows = filteredRows;

    let pretable = todateprocessed;
    pretable.sort(this.dynamicSort('consumidor'));
    let pretableBars = lastMprocessed;
    pretableBars.sort(this.dynamicSort('consumidor'));
    let preProyBars = QueryML;
    let table = [['M-A', 'consumidor' ]];
    let bars = [ ['Consumidor', 'Acumulado '+this.AcumulatedCurrentMonth, 'Proyectado '+this.ProyectedCurrentMonth, 'Consolidado '+this.TableLastMonth, 'Consolidado '+this.LastYrCurrentMonth]]
    //tabla #1
    pretable.sort(this.dynamicSortAlt('kwh'));
    if(this.consumersNames.length == 0 || pretable.length == 0)
    {
      table = [[
        "M-A",
        "consumidor"
      ]]
    }
    else
    {
      for(let consum in pretable)
      {
        table.push([pretable[consum].consumidor, pretable[consum].kwh])
      }
      console.log(table)
    }

    this.consumersChart.dataTable = table;
    this.consumersChart.dataTable.sort(this.dynamicSort('kwh'));
    let component = this.consumersChart.component;
    let wrapper = component.wrapper;
    component.draw();
    //barras #1
    pretable.sort(this.dynamicSort('consumidor'));
    for(let consum in pretableBars)
    {
      bars.push([pretableBars[consum].consumidor, pretable[consum].kwh,  QueryML[consum].kwh, pretableBars[consum].kwh4, 0])
    }
    bars.sort(this.dynamicSort('kwh'))
    this.CompareBarsChart.dataTable = bars;


    this.LastmonthTodateTotal_Energy = 0;
    this.LastmonthTodateTotal_Diesel = 0;
    this.LastmonthTodateTotal_Gas = 0;
    this.LastmonthTodateTotal_Agua = 0;

    for(let i in lastMprocessed){
      this.LastmonthTodateTotal_Energy += lastMprocessed[i].kWh;
      this.LastmonthTodateTotal_Diesel += lastMprocessed[i].Diesel;
      this.LastmonthTodateTotal_Gas += lastMprocessed[i].Gas;
      this.LastmonthTodateTotal_Agua += lastMprocessed[i].Agua;
    }

    ////////////////////////////////fin de ultimo mes diarios
    
    // //totales
    // this.monthTodateTotal_Energy = Math.round((this.monthTodateTotal_Energy + Number.EPSILON) * 100) / 100;
    // this.monthTodateTotal_Diesel = Math.round((this.monthTodateTotal_Diesel + Number.EPSILON) * 100) / 100;
    // this.monthTodateTotal_Gas = Math.round((this.monthTodateTotal_Gas + Number.EPSILON) * 100) / 100;
    // this.monthTodateTotal_Agua = Math.round((this.monthTodateTotal_Agua + Number.EPSILON) * 100) / 100;
    // //promedios
    // this.monthTodateProm_Energy = Math.round(((this.monthTodateTotal_Energy / monthsCount) + Number.EPSILON) * 100) / 100;
    // this.monthTodateProm_Diesel = Math.round(((this.monthTodateTotal_Diesel / monthsCount) + Number.EPSILON) * 100) / 100;
    // this.monthTodateProm_Gas = Math.round(((this.monthTodateTotal_Gas / monthsCount) + Number.EPSILON) * 100) / 100;
    // this.monthTodateProm_Agua = Math.round(((this.monthTodateTotal_Agua / monthsCount) + Number.EPSILON) * 100) / 100;

    //actualizo informacion de comparacion mes pasado.
    this.LastMonthkWh = 0;
    this.LastMonthDiesel = 0;
    this.LastMonthGas = 0;
    this.LastMonthAgua = 0;
    for(let f in QueryLastM){
      this.LastMonthkWh = Math.round(((this.LastMonthkWh + QueryLastM[f].kWh) + Number.EPSILON) * 100) / 100;
      this.LastMonthDiesel = Math.round(((this.LastMonthDiesel + QueryLastM[f].Diesel) + Number.EPSILON) * 100) / 100;
      this.LastMonthGas = Math.round(((this.LastMonthGas + QueryLastM[f].Gas) + Number.EPSILON) * 100) / 100;
      this.LastMonthAgua = Math.round(((this.LastMonthAgua + QueryLastM[f].Agua) + Number.EPSILON) * 100) / 100;
    }

    //actualizo informacion de proyeccion.
    this.TotalProykwh = 0;
    this.TotalProyusd = 0;
    for(let f in QueryML){
      this.TotalProykwh = Math.round(((this.TotalProykwh + QueryML[f].kwh) + Number.EPSILON) * 100) / 100;
      this.TotalProyusd = Math.round(((this.TotalProyusd + QueryML[f].usd) + Number.EPSILON) * 100) / 100;
    }
    this.setSize(null);
    this.isloadingDone = true;

  }

  actualizarWidget(QueryData, FalseData, QueryBL, QueryLastM, QueryML, otherData, chart, type){
    let kWhData = QueryData;
    let resultdata = [];
    //this.animate();

    kWhData.forEach(function (a) {
      if (!this[a.Fecha]) {
          this[a.Fecha] = { Fecha: a.Fecha, kWh: 0, Diesel: 0, Gas: 0, Agua: 0, Tonco2: 0,  kwh_m2: 0, m3_usr: 0, usd: 0};
          resultdata.push(this[a.Fecha]);
      }
      this[a.Fecha].kWh += a.kWh;
      this[a.Fecha].kWh = (Math.round((this[a.Fecha].kWh + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Diesel += a.Diesel;
      this[a.Fecha].Diesel = (Math.round((this[a.Fecha].Diesel + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Gas += a.Gas;
      this[a.Fecha].Gas = (Math.round((this[a.Fecha].Gas + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Agua += a.Agua;
      this[a.Fecha].Agua = (Math.round((this[a.Fecha].Agua + Number.EPSILON) * 100) / 100);
      this[a.Fecha].Tonco2 += a.Tonco2;
      this[a.Fecha].Tonco2 = (Math.round((this[a.Fecha].Tonco2 + Number.EPSILON) * 100) / 100);
      this[a.Fecha].kwh_m2 += a.kwh_m2;
      this[a.Fecha].kwh_m2 = (Math.round((this[a.Fecha].kwh_m2 + Number.EPSILON) * 100) / 100);
      this[a.Fecha].m3_usr += a.m3_usr;
      this[a.Fecha].m3_usr = (Math.round((this[a.Fecha].m3_usr + Number.EPSILON) * 100) / 100);
      this[a.Fecha].usd += a.usd;
      this[a.Fecha].usd = (Math.round((this[a.Fecha].usd + Number.EPSILON) * 100) / 100);
      
  }, Object.create(null));

  //actualizo los valores en tabla
  // for(let values in resultdata){
  //   this.Electr[values] = resultdata[values].kWh;
  //   this.Electr_usd[values] = resultdata[values].usd;
  //   this.Gas[values] = resultdata[values].Gas;
  //   this.Agua[values] = resultdata[values].Agua;
  //   //this.Tonco2[values] = resultdata[values].Tonco2 ;
  //   this.kwhm2[values] = resultdata[values].kwh_m2;
  //   this.m3_usr[values] = resultdata[values].m3_usr;
  //   this.totalkwh[values] = resultdata[values].kWh + (resultdata[values].Diesel*39.75) + (resultdata[values].Gas*12.6389);
  //   this.totalkwh[values] = (Math.round((this.totalkwh[values] + Number.EPSILON) * 100) / 100);
  //   this.Tonco2[values] = this.totalkwh[values] * 0.000266;
  //   this.Tonco2[values] =  (Math.round((this.Tonco2[values] + Number.EPSILON) * 100) / 100);
  // }

    //aqui actualizo los PROMEDIOS en tabla
    //electricidad
    // this.PromElectr = 0;
    // for(let i in this.Electr){
    //   this.PromElectr += this.Electr[i];   
    // } 
    // this.PromElectr =  Math.round(((this.PromElectr / this.Electr.length) + Number.EPSILON) * 100) / 100;
    // //electricidad USD
    // this.PromElectrUSD = 0;
    // for(let i in this.Electr_usd){
    //   this.PromElectrUSD += this.Electr_usd[i];   
    // } 
    // this.PromElectrUSD =  Math.round(((this.PromElectrUSD / this.Electr_usd.length) + Number.EPSILON) * 100) / 100;

    //se arman las lineas base - Ahora con tarifas
    let sitespreproc = QueryBL
    let newarray = [];
    sitespreproc.forEach(function (a) {
      if (!this[a.bd_id]) {
          this[a.bd_id] = { zone: a.zone, city: a.city, site: a.site, BL_elec: a.BL_elec, BL_diesel: a.BL_diesel, BL_gas: a.BL_gas, BL_agua: a.BL_agua, bd_id: a.bd_id};
          newarray.push(this[a.bd_id]);
      }
      this[a.bd_id].BL_elec = a.BL_elec * a.tarifa_kwh;
      this[a.bd_id].BL_elec = (Math.round((this[a.bd_id].BL_elec + Number.EPSILON) * 100) / 100);
      this[a.bd_id].BL_diesel = a.BL_diesel * a.tarifa_diesel;
      this[a.bd_id].BL_diesel = (Math.round((this[a.bd_id].BL_diesel + Number.EPSILON) * 100) / 100);
      this[a.bd_id].BL_gas = a.BL_gas * a.tarifa_gas;
      this[a.bd_id].BL_gas = (Math.round((this[a.bd_id].BL_gas + Number.EPSILON) * 100) / 100);
      this[a.bd_id].BL_agua = a.BL_agua * a.tarifa_agua;
      this[a.bd_id].BL_agua = (Math.round((this[a.bd_id].BL_agua + Number.EPSILON) * 100) / 100);

    }, Object.create(null));
    

    this.Blines = newarray;
    this.BL_kWh = 0;
    this.BL_Diesel = 0;
    this.BL_Gas = 0;
    this.BL_Agua = 0;

    for(let s in this.Blines){
      this.BL_kWh = (Math.round(((this.BL_kWh + this.Blines[s].BL_elec) + Number.EPSILON) * 100) / 100);
      this.BL_Diesel = (Math.round(((this.BL_Diesel + this.Blines[s].BL_diesel) + Number.EPSILON) * 100) / 100);
      this.BL_Gas = (Math.round(((this.BL_Gas + this.Blines[s].BL_gas) + Number.EPSILON) * 100) / 100);
      this.BL_Agua = (Math.round(((this.BL_Agua + this.Blines[s].BL_agua) + Number.EPSILON) * 100) / 100);
    }
    // console.log('Elec', this.BL_kWh)
    // console.log('Diesel', this.BL_Diesel)
    // console.log('Gas', this.BL_Gas)
    // console.log('Agua', this.BL_Agua)

    //Actualizo graficos y LineasBase
    if(type == 'Trendline')
    {
      chart.options.vAxis.baseline = (this.BL_kWh/1000).toString();
      console.log(this.Months, this.Electr_usd)
      if(this.Months.length > 1)
      {
        chart.dataTable = [
          ['M-A', 'CONSUMO (USD)', 'Linea Base (USD)'],
          [this.Months[0],  this.Electr_usd[0] , this.BL_kWh],
          [this.Months[1],  this.Electr_usd[1] , this.BL_kWh],
          [this.Months[2],  this.Electr_usd[2] , this.BL_kWh],
          [this.Months[3],  this.Electr_usd[3] , this.BL_kWh],
          [this.Months[4],  this.Electr_usd[4] , this.BL_kWh],
          [this.Months[5],  this.Electr_usd[5] , this.BL_kWh],
          [this.Months[6],  this.Electr_usd[6] , this.BL_kWh],
          [this.Months[7],  this.Electr_usd[7] , this.BL_kWh],
          [this.Months[8],  this.Electr_usd[8] , this.BL_kWh],
          [this.Months[9],  this.Electr_usd[9] , this.BL_kWh],
          [this.Months[10],  this.Electr_usd[10] , this.BL_kWh],
          [this.Months[11],  this.Electr_usd[11] , this.BL_kWh],
        ];
      }
      else
      {
        chart.dataTable = [
          ['M-A', 'CONSUMO (USD)', 'Linea Base (USD)'],
          ['',  '0' , '0'],
        ];
      }
      
    }
   

    let t2RowsNew = [];
    let tonnsNew = [['M-A', 'Ton CO2']];
    let kpi1New = [['M-A', 'KPI Consumo/Ventas (%)' ]];
    let kpi2New = [['M-A', 'KPI Consumo/Area (USD/m2)' ]];
    let kpi3New = [['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ]];
    let ventas = [];
    this.Diesel = [];
    this.Gas = [];
    this.Savings = [];

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////Separador de cirugia inicia////////////////////////////////////////////////////////////

    let consolidateMonths = [];
    let consolidateTonCO2 = [];
    let consolidateKPI1 = [];
    let consolidateKPI2 = [];
    let consolidateKPI3 = [];
    
    for(let month in this.Months)
    {
      let findMonth = false;
      let realMonth = this.transformMonth(this.Months[month])
      for(let data in kWhData)
      {
        let dataMonth = kWhData[data]['Fecha'].split('-')[1];
        if(realMonth == dataMonth)
        {
          findMonth = true
          for(let odata in otherData)
          {
            let oDate = new Date(otherData[odata]['date']).getMonth()
            oDate += 1;
            let id = kWhData[data]['Region'] + '-' + kWhData[data]['Ciudad'] + '-' + kWhData[data]['Sitio']
            if(realMonth == oDate && otherData[odata]['place'] == id)
            {
              let dieselTransf = 0;
              let gasTransf = 0;
              let Rbuffer = consolidateMonths[month];        
              //Agrego a los datos
              if(Rbuffer != undefined)
              {
                let bufferUSD = Rbuffer['consumousd']
                let bufferSavings = Rbuffer['ahorrousd']
                let bufferKWH = Rbuffer['electricidadkwh']
                let bufferDIESEL = Rbuffer['dieselgal']
                let bufferGAS = Rbuffer['gasm3']
                let bufferENERGY = Rbuffer['consumoenergia']
                let bufferCO2 = Rbuffer['emisionestonco2']
                let bufferSALES = Rbuffer['ventasusd']
                let bufferKPI1 = Rbuffer['KPI1']
                let bufferKPI2 = Rbuffer['KPI2']
                let bufferKPI3 = Rbuffer['KPI3']
                if(otherData[odata]['sales'] != 0)
                {
                  ventas[month] = ventas[month] + parseInt(otherData[odata]['sales']);
                  bufferKPI1 = bufferKPI1 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + (otherData[odata]['gas']*12.6389)*0.1 )/ otherData[odata]['sales']);
                }
                if(otherData[odata]['diesel'] != '0')
                  {this.Diesel[month] = this.Diesel[month] + parseFloat(otherData[odata]['diesel']); dieselTransf=(otherData[odata]['diesel']*39.75)*1  }else{dieselTransf = 0;}
                if(otherData[odata]['gas'] != '0')
                  {this.Gas[month] = this.Gas[month] + parseFloat(otherData[odata]['gas']); gasTransf = (otherData[odata]['gas']*12.6389)*0.1}else{gasTransf = 0}
                bufferUSD = bufferUSD + kWhData[data]['usd'];
                bufferSavings = bufferSavings + kWhData[data]['usd']//(this.BL_kWh - kWhData[data]['usd']);
                bufferKWH = bufferKWH + kWhData[data]['kWh']
                bufferDIESEL = bufferDIESEL + parseFloat(otherData[odata]['diesel']);
                bufferGAS = bufferGAS + parseFloat(otherData[odata]['gas']);
                bufferENERGY = bufferENERGY + (kWhData[data]['kWh'] + otherData[odata]['diesel']*39.75 + otherData[odata]['gas']*12.6389);
                bufferCO2 = bufferCO2 + kWhData[data]['Tonco2'];
                bufferSALES = bufferSALES + parseFloat(otherData[odata]['sales']);
                bufferKPI2 = bufferKPI2 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1 )+ ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2']);
                bufferKPI3 = bufferKPI3 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) ) / otherData[odata]['users']);
                bufferSavings = this.BL_kWh - bufferUSD;
                consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': bufferUSD, 'ahorrousd': bufferSavings, 'electricidadkwh': bufferKWH, "dieselgal": bufferDIESEL, "gasm3": bufferGAS, "consumoenergia": bufferENERGY, 'emisionestonco2': bufferCO2, 'ventasusd': bufferSALES, 'KPI1': bufferKPI1, 'KPI2': bufferKPI2, 'KPI3': bufferKPI3}
              }
              else
              {
                if(otherData[odata]['diesel'] != '0')
                  {this.Diesel[month] = parseFloat(otherData[odata]['diesel']); dieselTransf=(otherData[odata]['diesel']*39.75)*1  }else{dieselTransf = 0;}
                if(otherData[odata]['gas'] != '0')
                  {this.Gas[month] = parseFloat(otherData[odata]['gas']); gasTransf = (otherData[odata]['gas']*12.6389)*0.1}else{gasTransf = 0}
                if(otherData[odata]['sales'] != 0)
                {
                  ventas[month] = parseInt(otherData[odata]['sales']);
                  consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': kWhData[data]['usd'], 'ahorrousd': this.BL_kWh - kWhData[data]['usd'], 'electricidadkwh': kWhData[data]['kWh'], "dieselgal": parseFloat(otherData[odata]['diesel']) , "gasm3": parseFloat(otherData[odata]['gas']), "consumoenergia": kWhData[data]['kWh'] + otherData[odata]['diesel']*39.75 + otherData[odata]['gas']*12.6389, 'emisionestonco2': kWhData[data]['Tonco2'] + (((otherData[odata]['diesel']*39.75) + (otherData[odata]['gas']*12.6389))*0.000266), 'ventasusd': parseFloat(otherData[odata]['sales']), 'KPI1': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + (otherData[odata]['gas']*12.6389)*0.1 )/ otherData[odata]['sales'], 'KPI2': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1 )+ ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2'], 'KPI3':(kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) ) / otherData[odata]['users']}
                }
                else
                {
                  consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': kWhData[data]['usd'], 'ahorrousd': this.BL_kWh - kWhData[data]['usd'], 'electricidadkwh': kWhData[data]['kWh'], "dieselgal": parseFloat(otherData[odata]['diesel']) , "gasm3": parseFloat(otherData[odata]['gas']), "consumoenergia": kWhData[data]['kWh'] + otherData[odata]['diesel']*39.75 + otherData[odata]['gas']*12.6389, 'emisionestonco2': kWhData[data]['Tonco2']+ (((otherData[odata]['diesel']*39.75) + (otherData[odata]['gas']*12.6389))*0.000266), 'ventasusd': parseFloat(otherData[odata]['sales']), 'KPI1': 0, 'KPI2': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1 )+ ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2'], 'KPI3':(kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) ) / otherData[odata]['users']}
                }
              }  
              //console.log(consolidateMonths);
              //Agrego a TonCO2
              let TonBuffer= consolidateTonCO2[month];       
              if( TonBuffer != undefined)
              {
                let lastTon = consolidateTonCO2[month]['Tons'];
                lastTon = lastTon + kWhData[data]['Tonco2'];
                consolidateTonCO2[month] = {"Mes": this.Months[month], 'Tons': lastTon}
              }
              else
              {
                consolidateTonCO2[month] = {"Mes": this.Months[month], 'Tons': kWhData[data]['Tonco2']+ (((otherData[odata]['diesel']*39.75) + (otherData[odata]['gas']*12.6389))*0.000266)}
              }
              //Agrego KPI1
              let kpi1Buffer = consolidateKPI1[month]
              if( kpi1Buffer != undefined)
              {
                if(otherData[odata]['sales'] != 0)
                {
                  let lastKPI1 = consolidateKPI1[month]['kpi1']
                  lastKPI1 = lastKPI1 + ((kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['sales'] );
                  consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': lastKPI1 }
                }
              }
              else
              {
                if(otherData[odata]['sales'] != 0)
                {
                  consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': (kWhData[data]['usd'] + ((otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['sales']  }
                }
                else
                {
                  consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': 0 }
                }
              }
              //Agrego KPI2
              let kpi2Buffer = consolidateKPI2[month]
              if( kpi2Buffer != undefined)
              {
                let lastkpi2 = consolidateKPI2[month]['kpi2']
                lastkpi2 = lastkpi2 + ((kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2']);
                consolidateKPI2[month] = {"Mes": this.Months[month], 'kpi2': lastkpi2}
              }
              else
              {
                consolidateKPI2[month] = {"Mes": this.Months[month], 'kpi2': (kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['m2']}
              }
              //Agrego KPI3
              let kpi3Buffer = consolidateKPI3[month]
              if( kpi3Buffer != undefined)
              {
                let lastkpi3 = consolidateKPI3[month]['kpi3']
                lastkpi3 = lastkpi3 + ( (kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['users']);
                consolidateKPI3[month] = {"Mes": this.Months[month], 'kpi3': lastkpi3 };
              }
              else
              {
                consolidateKPI3[month] = {"Mes": this.Months[month], 'kpi3': (kWhData[data]['usd'] + ( (otherData[odata]['diesel']*39.75)*1) + ((otherData[odata]['gas']*12.6389)*0.1) )/ otherData[odata]['users'] };
              }
            }
          }
        }        
      }
      if(!findMonth)
      {
        consolidateMonths[month] = {"Mes": this.Months[month],  'consumousd': 0, 'ahorrousd': 0, 'electricidadkwh': 0, "dieselgal": 0, "gasm3": 0, "consumoenergia": 0, 'emisionestonco2': 0, 'ventasusd': 0, 'KPI1': 0, 'KPI2': 0, 'KPI3': 0}
        consolidateTonCO2[month] = {"Mes": this.Months[month], 'Tons': null};
        consolidateKPI1[month] = {"Mes": this.Months[month], 'kpi1': null};
        consolidateKPI2[month] = {"Mes": this.Months[month], 'kpi2': null};
        consolidateKPI3[month] = {"Mes": this.Months[month], 'kpi3': null};
      }
    }
    
    tonnsNew = [['M-A', 'Ton CO2']];
    for(let ton in consolidateTonCO2)
    {
      tonnsNew.push([consolidateTonCO2[ton]['Mes'], consolidateTonCO2[ton]['Tons']]);
    }
    
    kpi1New = [['M-A', 'KPI Consumo/Ventas (%)' ]];
    for(let kpi in consolidateKPI1)
    {
      kpi1New.push([consolidateKPI1[kpi]['Mes'], consolidateKPI1[kpi]['kpi1']]);
      if(consolidateKPI1[kpi]['kpi1'] != null)
      {
        this.KPI1_list.push(consolidateKPI1[kpi]['kpi1']);
      }
    }
    kpi2New = [['M-A', 'KPI Consumo/Area (USD/m2)' ]];
    for(let kpi in consolidateKPI2)
    {
      kpi2New.push([consolidateKPI2[kpi]['Mes'], consolidateKPI2[kpi]['kpi2']]);
      if(consolidateKPI2[kpi]['kpi2'] != null)
      {
        this.KPI2_list.push(consolidateKPI2[kpi]['kpi2']);
      }
    }
    kpi3New = [['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ]];
    for(let kpi in consolidateKPI3)
    {
      kpi3New.push([consolidateKPI3[kpi]['Mes'], consolidateKPI3[kpi]['kpi3']]);
      if(consolidateKPI3[kpi]['kpi3'] != null)
      {
        this.KPI3_list.push(consolidateKPI3[kpi]['kpi3']);
      }
    }
    t2RowsNew = [];
    for(let value in consolidateMonths)
    {
      t2RowsNew.push(consolidateMonths[value])
      if(consolidateMonths[value]['ahorrousd'] != 0)
        {this.Savings.push(consolidateMonths[value]['ahorrousd']);}
    }



    
    ////////////////////////////////Separador de cirugia termina////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    //genero promedio de ahorros y KPI
    //Prom tonco2
    // this.PromTonco2 = 0;
    // let len = 0;
    // for(let i in consolidateTonCO2)
    // {
    //   if(consolidateTonCO2[i]['Tons'] != null){len += 1;};
    //   this.PromTonco2 += consolidateTonCO2[i]['Tons'];
    // }
    // this.PromTonco2 = Math.round(((this.PromTonco2 / len) + Number.EPSILON) * 100) / 100; 
    // //Prom totalkwh
    // this.Promtotalkwh = 0;
    // let len2 = 0;
    // for(let i in consolidateMonths)
    // {
    //   this.Promtotalkwh += consolidateMonths[i]['consumoenergia'];
    // }
    // this.Promtotalkwh = Math.round(((this.Promtotalkwh / len) + Number.EPSILON) * 100) / 100; 
    // //Prom Diesel
    // let filteredDiesel = ventas.filter(function (el) {
    //   return el != null;
    // });
    // this.PromDiesel = 0;
    // for(let i in filteredDiesel)
    // {
    //   this.PromDiesel += parseInt(filteredDiesel[i]);
    // }
    // this.PromDiesel = Math.round(((this.PromDiesel / filteredDiesel.length) + Number.EPSILON) * 100) / 100; 
    // //Prom Gas
    // let filteredGas = ventas.filter(function (el) {
    //   return el != null;
    // });
    // this.PromGas = 0;
    // for(let i in filteredGas)
    // {
    //   this.PromGas += parseInt(filteredGas[i]);
    // }
    // this.PromGas = Math.round(((this.PromGas / filteredGas.length) + Number.EPSILON) * 100) / 100; 
    // //ventas prom
    // let filtered = ventas.filter(function (el) {
    //   return el != null;
    // });
    // this.PromSales = 0;
    // for(let i in filtered){
    //   this.PromSales += parseInt(filtered[i]);   
    // } 
    // this.PromSales =  Math.round(((this.PromSales / filtered.length) + Number.EPSILON) * 100) / 100; 
    // //ahorro USD
    // this.PromUSDSavings = 0;
    // for(let i in this.Savings){
    //   this.PromUSDSavings += this.Savings[i];   
    // } 
    // this.PromUSDSavings =  Math.round(((this.PromUSDSavings / this.Savings.length) + Number.EPSILON) * 100) / 100;
    // // KPI1
    // this.PromKPI1 = 0;
    // for(let i in this.KPI1_list){
    //   this.PromKPI1 += this.KPI1_list[i];   
    // } 
    // this.PromKPI1 =  Math.round(((this.PromKPI1 / this.KPI1_list.length) + Number.EPSILON) * 100) / 100;
    // // KPI2
    // this.PromKPI2 = 0;
    // for(let i in this.KPI2_list){
    //   this.PromKPI2 += this.KPI2_list[i];   
    // } 
    // this.PromKPI2 =  Math.round(((this.PromKPI2 / this.KPI2_list.length) + Number.EPSILON) * 100) / 100;
    // // KPI3
    // this.PromKPI3 = 0;
    // for(let i in this.KPI3_list){
    //   this.PromKPI3 += this.KPI3_list[i];   
    // } 
    // this.PromKPI3 =  Math.round(((this.PromKPI3 / this.KPI3_list.length) + Number.EPSILON) * 100) / 100;

    //actualizo los valores de la tabla #2 
    //this.t2rows = t2RowsNew;
    //console.log(this.t2rows);
    //Actualizo las graficas finales
    //this.co2Chart.dataTable = tonnsNew;
    if(type == 'KPI1')
    {
      chart.dataTable = tonnsNew;
    }
    if(type == 'KPI2')
    {
      chart.dataTable = kpi2New;
    }
    // this.KPI1Chart.dataTable = kpi1New;
    if(type == 'KPI3')
    {
      chart.dataTable = kpi3New;
    }
    // this.KPI2Chart.dataTable = kpi2New;
    // this.KPI3Chart.dataTable = kpi3New;

    //actualizo los valores mensuales y promedio a fecha
    //obtener mes actual para comparar
    let todatedatafull = FalseData;
    let todateprocessed = [];
    let todateProyect = [];
    let todateProyectprocessed = [];
    let lastMprocessed = [];
    let filteredRows = [];
    let monthsCount = 0;


    let dummy = this.MonthdateControl.value;
    let fd = new Date(dummy.getFullYear(), dummy.getMonth(), 1),
        month = '' + (fd.getMonth() + 1),
        day = '' + fd.getDate(),
        year = fd.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    //obtengo ultimo dia del mes anterior
    let startDate = [year, month, day].join('-');
    todatedatafull = FalseData.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= new Date(startDate);
    });
    
    //obtengo ultimo dia del mes anterior proyeccion aritmetica
    todateProyect = FalseData.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= new Date(startDate);
    });

    if(todatedatafull.length == 0){ //si es el primer dia y no hay datos no lleno valores.
      for(let consumer in this.consumersNames){
        todateprocessed.push({ consumidor: this.consumersNames[consumer], kwh: 0, usd: 0});
      }
    }else{ //si ya hay datos relleno valores
      todatedatafull.forEach(function (a) {
      if (!this[a.consumidor]) {
          this[a.consumidor] = { consumidor: a.consumidor, kwh: 0, usd: 0};
          todateprocessed.push(this[a.consumidor]);
          monthsCount += 1;
      }      
      this[a.consumidor].kwh += a.valor;
      this[a.consumidor].kwh = (Math.round((this[a.consumidor].kwh + Number.EPSILON) * 100) / 100);
      this[a.consumidor].usd += a.valor_usd;
      this[a.consumidor].usd = (Math.round((this[a.consumidor].usd + Number.EPSILON) * 100) / 100);
      }, Object.create(null));      
    }

    if(todateProyect.length == 0){
      for(let consumer in this.consumersNames){
        todateProyect.push({ consumidor: this.consumersNames[consumer], kwh: 0, usd: 0});
      }
    }else{//aqui lleno los valores de proyeccion aritmetica
      todateProyect.forEach(function (a) {
        if (!this[a.consumidor]) {
            this[a.consumidor] = { consumidor: a.consumidor, kwh: 0, usd: 0};
            todateProyectprocessed.push(this[a.consumidor]);
            //monthsCount += 1;
        }
        
        this[a.consumidor].kwh += a.valor;
        this[a.consumidor].kwh = (Math.round((this[a.consumidor].kwh + Number.EPSILON) * 100) / 100);
        this[a.consumidor].usd += a.valor_usd;
        this[a.consumidor].usd = (Math.round((this[a.consumidor].usd + Number.EPSILON) * 100) / 100);
        }, Object.create(null));
    }
    todateprocessed.sort(this.dynamicSort('consumidor')); 
    todateProyectprocessed.sort(this.dynamicSort('consumidor')); 

    //obtiene los dias faltantes en el mes corriendo
    var getRemanningDays = function () {
      var date = new Date();
      var time = new Date(date.getTime());
      time.setMonth(date.getMonth() + 1);
      time.setDate(0);
      return(time.getDate() > date.getDate() ? time.getDate() - date.getDate() : 0);
    }
    let remainingDays = getRemanningDays() + 1;
    let currentDays = new Date().getDate() - 1;
    if(!this.LookingCurrentMonth){
      remainingDays = 0;
    }

    if(remainingDays != 0){
      for(let x in todateProyectprocessed)
      {
        todateProyectprocessed[x].kwh = ((todateProyectprocessed[x].kwh / currentDays)*remainingDays)+todateProyectprocessed[x].kwh;
        todateProyectprocessed[x].usd = ((todateProyectprocessed[x].usd / currentDays)*remainingDays)+todateProyectprocessed[x].usd;
      }
    }

    this.monthTodateTotal_Energy = 0;
    this.monthTodateTotal_Diesel = 0;
    this.monthTodateTotal_Gas = 0;
    this.monthTodateTotal_Agua = 0;
    this.monthTodateProm_Energy = 0;
    this.monthTodateProm_Diesel = 0;
    this.monthTodateProm_Gas = 0;
    this.monthTodateProm_Agua = 0;

    for(let i in todateprocessed){
        this.monthTodateTotal_Energy += todateprocessed[i].kWh;
        this.monthTodateTotal_Diesel += todateprocessed[i].Diesel;
        this.monthTodateTotal_Gas += todateprocessed[i].Gas;
        this.monthTodateTotal_Agua += todateprocessed[i].Agua;
      }
    ///////////////////////////////////Obtener valores diarios mes anterior
      let fs = new Date(),
          monthl = '' + (fs.getMonth()),
          dayl = '' + fs.getDate(),
          yearl = fs.getFullYear();

      if (monthl.length < 2) 
          monthl = '0' + monthl;
      if (day.length < 2) 
          dayl = '0' + dayl;

      let endDate = [yearl, monthl, dayl].join('-');
      let lasttodatedatafull = [];
      // lasttodatedatafull = QueryLastM.filter(function(a){
      //   let aDate = new Date(a.Fecha);
      //   return aDate < new Date(endDate);
      // });
      lasttodatedatafull = QueryLastM;

      lasttodatedatafull.forEach(function (a) {
        if (!this[a.consumidor]) {
            this[a.consumidor] = { consumidor: a.consumidor, kwh4: 0, usd4: 0};
            lastMprocessed.push(this[a.consumidor]);
        }
        
        this[a.consumidor].kwh4 += a.valor;
        this[a.consumidor].kwh4 = (Math.round((this[a.consumidor].kwh4 + Number.EPSILON) * 100) / 100);
        this[a.consumidor].usd4 += a.valor_usd;
        this[a.consumidor].usd4 = (Math.round((this[a.consumidor].usd4 + Number.EPSILON) * 100) / 100);
    }, Object.create(null));
    lastMprocessed.sort(this.dynamicSort('consumidor'));

    //QueryML = this.Proyections;
    QueryML = todateProyectprocessed;
    if(QueryML == '')
    {
      for(let consumer in this.consumersNames){
        QueryML.push({ consumidor: this.consumersNames[consumer], kwh: 0, usd: 0});
      }
    }
    QueryML.sort(this.dynamicSort('site'));
    for(let consum in todateprocessed){
      filteredRows[consum] = {consumidor: todateprocessed[consum].consumidor, kwh: todateprocessed[consum].kwh, usd: todateprocessed[consum].usd, kwh2: QueryML[consum].kwh, usd2: QueryML[consum].usd, kwh3: 0, usd3: 0, index1: 'neut', kwh4: lastMprocessed[consum].kwh4, usd4: lastMprocessed[consum].usd4, index2: 'neut' }
      if(filteredRows[consum].kwh2 < filteredRows[consum].kwh3 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index1 = 'inc'};
      if(filteredRows[consum].kwh2 > filteredRows[consum].kwh3 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index1 = 'dec'};
      if(filteredRows[consum].kwh2 == filteredRows[consum].kwh3 || filteredRows[consum].kwh2 == 0 || filteredRows[consum].kwh3 == 0){filteredRows[consum].index1 = 'neut'}
      if(filteredRows[consum].kwh2 > filteredRows[consum].kwh4 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index2 = 'inc'};
      if(filteredRows[consum].kwh2 < filteredRows[consum].kwh4 && filteredRows[consum].kwh2 != 0){filteredRows[consum].index2 = 'dec'};
      if(filteredRows[consum].kwh2 == filteredRows[consum].kwh4 || filteredRows[consum].kwh2 == 0){filteredRows[consum].index2 = 'neut'};
    }

    //se suman todos los consumidores para totales
    let totals = {totalkwh: 0, totalusd: 0, totalkwh2: 0, totalusd2: 0, totalkwh3: 0, totalusd3: 0, totalindex1: 'und', totalkwh4: 0, totalusd4: 0, totalindex2: 'und'};
    for(let cons in filteredRows){
      totals.totalkwh += filteredRows[cons].kwh
      totals.totalkwh =  (Math.round((totals.totalkwh + Number.EPSILON) * 100) / 100);
      totals.totalusd += filteredRows[cons].usd
      totals.totalusd =  (Math.round((totals.totalusd + Number.EPSILON) * 100) / 100);
      
      totals.totalkwh2 += filteredRows[cons].kwh2
      totals.totalkwh2 =  (Math.round((totals.totalkwh2 + Number.EPSILON) * 100) / 100);
      totals.totalusd2 += filteredRows[cons].usd2
      totals.totalusd2 =  (Math.round((totals.totalusd2 + Number.EPSILON) * 100) / 100);
      
      totals.totalkwh3 += filteredRows[cons].kwh3
      totals.totalkwh3 =  (Math.round((totals.totalkwh3 + Number.EPSILON) * 100) / 100);
      totals.totalusd3 += filteredRows[cons].usd3
      totals.totalusd3 =  (Math.round((totals.totalusd3 + Number.EPSILON) * 100) / 100);
      
      totals.totalkwh4 += filteredRows[cons].kwh4
      totals.totalkwh4 =  (Math.round((totals.totalkwh4 + Number.EPSILON) * 100) / 100);
      totals.totalusd4 += filteredRows[cons].usd4
      totals.totalusd4 =  (Math.round((totals.totalusd4 + Number.EPSILON) * 100) / 100);
    }
    //se asignan los totales a los parametros globales para tabla
    // this.TotalCurrentkwh = totals.totalkwh;
    // this.TotalCurrentusd = totals.totalusd;
    // this.TotalProykwh = totals.totalkwh2;
    // this.TotalProyusd = totals.totalusd2;
    // this.TotalLastYrkwh = totals.totalkwh3;
    // this.TotalLastYrusd = totals.totalusd3;
    // this.TotalLastMnthkwh = totals.totalkwh4;
    // this.TotalLastMnthusd = totals.totalusd4;

    // this.rows = filteredRows;

    let pretable = todateprocessed;
    pretable.sort(this.dynamicSort('consumidor'));
    let pretableBars = lastMprocessed;
    pretableBars.sort(this.dynamicSort('consumidor'));
    let preProyBars = QueryML;
    let table = [['M-A', 'consumidor' ]];
    let bars = [ ['Consumidor', 'Acumulado '+this.AcumulatedCurrentMonth, 'Proyectado '+this.ProyectedCurrentMonth, 'Consolidado '+this.TableLastMonth, 'Consolidado '+this.LastYrCurrentMonth]]
    //tabla #1
    pretable.sort(this.dynamicSortAlt('kwh'))
    for(let consum in pretable)
    {
      table.push([pretable[consum].consumidor, pretable[consum].kwh])
    }

    if(type == 'PieConsumers')
    {
      chart.dataTable = table;
      chart.dataTable.sort(this.dynamicSort('kwh'));
      let component = chart.component;
      let wrapper = component.wrapper;
      component.draw();
    }
    
    //barras #1
    pretable.sort(this.dynamicSort('consumidor'));
    for(let consum in pretableBars)
    {
      bars.push([pretableBars[consum].consumidor, pretable[consum].kwh,  QueryML[consum].kwh, pretableBars[consum].kwh4, 0])
    }
    bars.sort(this.dynamicSort('kwh'))
    this.CompareBarsChart.dataTable = bars;


    this.LastmonthTodateTotal_Energy = 0;
    this.LastmonthTodateTotal_Diesel = 0;
    this.LastmonthTodateTotal_Gas = 0;
    this.LastmonthTodateTotal_Agua = 0;

    for(let i in lastMprocessed){
      this.LastmonthTodateTotal_Energy += lastMprocessed[i].kWh;
      this.LastmonthTodateTotal_Diesel += lastMprocessed[i].Diesel;
      this.LastmonthTodateTotal_Gas += lastMprocessed[i].Gas;
      this.LastmonthTodateTotal_Agua += lastMprocessed[i].Agua;
    }

    //actualizo informacion de comparacion mes pasado.
    // this.LastMonthkWh = 0;
    // this.LastMonthDiesel = 0;
    // this.LastMonthGas = 0;
    // this.LastMonthAgua = 0;
    // for(let f in QueryLastM){
    //   this.LastMonthkWh = Math.round(((this.LastMonthkWh + QueryLastM[f].kWh) + Number.EPSILON) * 100) / 100;
    //   this.LastMonthDiesel = Math.round(((this.LastMonthDiesel + QueryLastM[f].Diesel) + Number.EPSILON) * 100) / 100;
    //   this.LastMonthGas = Math.round(((this.LastMonthGas + QueryLastM[f].Gas) + Number.EPSILON) * 100) / 100;
    //   this.LastMonthAgua = Math.round(((this.LastMonthAgua + QueryLastM[f].Agua) + Number.EPSILON) * 100) / 100;
    // }

    // //actualizo informacion de proyeccion.
    // this.TotalProykwh = 0;
    // this.TotalProyusd = 0;
    // for(let f in QueryML){
    //   this.TotalProykwh = Math.round(((this.TotalProykwh + QueryML[f].kwh) + Number.EPSILON) * 100) / 100;
    //   this.TotalProyusd = Math.round(((this.TotalProyusd + QueryML[f].usd) + Number.EPSILON) * 100) / 100;
    // }
    this.setSize(null);
    this.isloadingDone = true;

  }

  openDatePicker(dp) {
    dp.open();
  }

  closeDatePicker1(eventData: any, dp?:any) {
    this.isloadingDone = false;
    this.sidenav.close();
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let lastDate = this.MonthdateControl.value;

    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    let lastDay = new Date(date.getFullYear(), date.getMonth()+1, 0).getDate()
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);
    this.MonthdateControl.setValue(new Date(lastDayOfMonth));
    this.MonthdateControl.updateValueAndValidity();

    month = (lastDayOfMonth.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let fulldate = [lastDayOfMonth.getFullYear(), month, lastDayOfMonth.getDate()].join('-');

    //obtengo el mes anterior al seleccionado
    let dummylastMonth = new Date(lastDayOfMonth).setDate(0);
    this.LastMonthtoCompare = [months[new Date(dummylastMonth).getMonth()], new Date(dummylastMonth).getFullYear()].join('-');
    let lMonth = (new Date(dummylastMonth).getMonth() + 1).toString();
    lMonth = lMonth.length > 1 ? lMonth : '0' + lMonth;
    let lastMonth = [new Date(dummylastMonth).getFullYear(), lMonth, new Date(dummylastMonth).getDate()].join('-');
    
    

    //actualizo los encabezados para las tablas (Fechas)
    this.AcumulatedCurrentMonth = [lastDay, months[date.getMonth()], year].join('-');
    this.ProyectedCurrentMonth = [lastDay, months[date.getMonth()], year].join('-');
    
    this.LastYrCurrentMonth = [months[date.getMonth()], date.getFullYear()-1].join('-');
    this.TableLastMonth = [months[parseInt(lMonth)-1], new Date(dummylastMonth).getFullYear()].join('-');

    this.isloadingTable = false;
    this.LoadingLastConsumers = false
    if(lastDayOfMonth.getTime() === lastDate.getTime())
    {console.log('Misma fecha seleccionada');this.isloadingTable = true;this.isloadingDone = true;}
    else
    {
      if(lastDayOfMonth.getMonth() === new Date().getMonth())
      {
        console.log('es esta fecha no se busca de BD ya esta en memoria')
        this.LookingCurrentMonth = true;
        let NewDate = new Date();
        let thisYear = NewDate.getFullYear();
        let thisMonth = months[NewDate.getMonth()];
        let thisDay = new Date().getDate() - 1;
        this.AcumulatedCurrentMonth = [thisDay, thisMonth, thisYear].join('-');
        this.actualizarTabla(this.originalQuery, this.falseQuery, this.OriginalBLQuery, this.false_last_month_original, this.false_last_month_predict, this.otherData);
        
        this.isloadingTable = true;
        this.isloadingDone = true;
      }
      else
      {
        let sub = this.requestService.sendDailyRequestParams(fulldate).subscribe(result =>{
          this.ParamsQueryDaily = [];
          for(let item in result){
            if((result[item][3] == "OTROS") || (result[item][3] == "Otros"))
            {
              this.ParamsQueryDaily.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  "VARIOS", 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})
            }
            else
            {
              this.ParamsQueryDaily.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  result[item][3], 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})
            }
            
          }
          sub.unsubscribe();
          this.isloadingTable = true;
          this.LookingCurrentMonth = false;
          this.DateChangeOneTime();
          //this.actualizarTabla(this.originalQuery, this.ParamsQueryDaily, this.OriginalBLQuery, this.false_last_month_original, this.false_last_month_predict, this.otherData);
        })

        let sub2 = this.requestService.sendDConsumerRequestParams(lastMonth).subscribe(result =>{
          this.ParamsQueryLastMonth = [];
          console.log(result);
          for(let item in result){
            if((result[item][3] == "OTROS") || (result[item][3] == "Otros"))
            {
              this.ParamsQueryLastMonth.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  'VARIOS', 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})
            }
            else
            {
              this.ParamsQueryLastMonth.push({'Region': result[item][0], 'Ciudad':  result[item][1], 'Sitio':  result[item][2], 'consumidor':  result[item][3], 'Fecha':  result[item][4], 'valor':  result[item][5], 'valor_usd':  result[item][6]})
            }
            
          }
          this.LoadingLastConsumers = true;
          sub2.unsubscribe();
          this.DateChangeOneTime();
          //this.actualizarTabla(this.originalQuery, this.ParamsQueryDaily, this.OriginalBLQuery, this.ParamsQueryLastMonth, this.false_last_month_predict, this.otherData);
        })
      }      
    }    
    dp.close();
  }

  DateChangeOneTime(){
    this.Nivel = 'Nivel País'
    this.TopLvlSelected = '';
    this.MidLvlSelected = '';
    this.LastLvlSelected = '';
    if(this.isloadingTable && this.LoadingLastConsumers){
      this.actualizarTabla(this.originalQuery, this.ParamsQueryDaily, this.OriginalBLQuery, this.ParamsQueryLastMonth, this.false_last_month_predict, this.otherData);
      this.isloadingDone = true;
    }
  }

  //--------- Para agregar widgets -------
  addTrendlineWidget(id, alias){
    var dummy = id.split("-");;
    let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
    let s = this.dashboard.length;
    let chartd = {
      chartType: 'LineChart',
      dataTable: [
        // ['M-A', 'CONSUMO (USD)', 'Objetivo (USD)'],
        // [' ',  1, 4]
      ],
      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7', fontName: 'Arial Black'}},
      borderWidth: 1,
      height: 250,
      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
      animation: {duration: 800, easing: 'inAndOut'},
      hAxis: {
        visible: 'true',
        textPosition: 'left',
        textStyle:{color: '#3f6ab7'},
        
       },
      vAxis: {
        format: "short",
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        titleTextStyle:{color: 'white'},
        gridlines: {color: 'gray'},
        position: 'in',
        viewWindow: {
                      min:0
                    }
      },
      series: {
        0: {pointsVisible: true},
        1: {type: 'line',lineDashStyle: [10, 2]}},
      options: {
        responsive: true
      },
  
      //  colors: ['#4875c5', '#a8a8a8', '#619dd6', '#2f4b80'],
  
       lineWidth: 2.8,
  
      // pointShape: "circle",
      // pointSize: 4, 
      // pointSizeShadow: 0,
      forcelFrame: "true",
  
       curveType: "linear",
                 
                }
    }; 
    this.dashboard.push({cols: 4, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'Trendline', resizeEnabled: true, label: label, chart: chartd, id: id, filter: null});
    console.log(this.dashboard);
    let passtr = this.dashboard
    //this.dashObjs.push({cols: 4, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'Trendline', resizeEnabled: true, label: label, chart: '', id: id, filter: null})
    //-----Aqui va el sub de datos para rellenar temp simple
    this.delay(100).then(() =>{
      this.authService.UpdateUserDashboardGeren(this.app.userUid, passtr, 0, this.app.selectedProyect['id'])
    })
    

    this.widgetsElementRef.close();
  }

  addConsumerPieWidget(id, alias){
    var dummy = id.split("-");;
    let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
    let s = this.dashboard.length;
    let chartd = {
      chartType: 'PieChart',
      dataTable: [
        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
        // [' ',  0]
      ],
      options: { legend: {position: 'right', textStyle:{color: '#3f6ab7'}},
      borderWidth: 1,
      height: 255,
      chartArea: { left: 5, right: 10, top: 30, height: '80%'}, 
      animation: {duration: 800, easing: 'inAndOut'},
      hAxis: {
        visible: 'true',
        textPosition: 'left'
        
       },
      vAxis: {
        format: "short",
        visible: 'true',
        // textStyle:{color: '#FFF'},
        titleTextStyle:{color: 'white'},
        gridlines: {color: 'gray'},
        position: 'in',
        viewWindow: {
                      min:0
                    }
      },
      lineWidth: 2.8,
      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
      pointShape: "circle",
      pointSize: 4, 
      pointSizeShadow: 0,
      forcelFrame: "true",
  
       curveType: "linear",
                 
                }
    };
    this.dashboard.push({cols: 2, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'PieConsumers', resizeEnabled: true, label: label, chart: chartd, id: id, filter: null});
    //this.dashObjs.push({cols: 2, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'PieConsumers', resizeEnabled: true, label: label, chart: '', id: id, filter: null})
    //-----Aqui va el sub de datos para rellenar temp simple
    this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
    this.widgetsElementRef.close();
  }

  addKPI1Widget(id, alias){
    var dummy = id.split("-");;
    let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
    let s = this.dashboard.length;
    let chart = {
      chartType: 'AreaChart',
      dataTable: [
        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
        // [' ',  0]
      ],
      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
      borderWidth: 1,
      height: 255,
      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
      animation: {duration: 800, easing: 'inAndOut'},
      hAxis: {
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        textPosition: 'left'
        
       },
      vAxis: {
        format: "short",
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        titleTextStyle:{color: 'white'},
        gridlines: {color: 'gray'},
        position: 'in',
        viewWindow: {
                      min:0
                    }
      },
      colors: ['#A8A8A8'],
      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
      pointShape: "circle",
      pointSize: 4, 
      pointSizeShadow: 0,
      forcelFrame: "true",
      curveType: "linear",           
       }
    };
    this.dashboard.push({cols: 2, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'KPI1', resizeEnabled: true, label: label, chart: chart, id: id, filter: null});
    console.log(this.dashboard);
    this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id']);
    this.widgetsElementRef.close();
  }

  addKPI2Widget(id, alias){
    var dummy = id.split("-");;
    let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
    let s = this.dashboard.length;
    let chartd = {
      chartType: 'ColumnChart',
      dataTable: [
        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
        // [' ',  0]
      ],
      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
      borderWidth: 1,
      height: 255,
      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
      animation: {duration: 800, easing: 'inAndOut'},
      hAxis: {
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        textPosition: 'left'
        
       },
      vAxis: {
        format: "short",
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        titleTextStyle:{color: 'white'},
        gridlines: {color: 'gray'},
        position: 'in',
        viewWindow: {
                      min:0
                    }
      },
      lineWidth: 2.8,
      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
      pointShape: "circle",
      pointSize: 4, 
      pointSizeShadow: 0,
      forcelFrame: "true",
      colors: ['#DC3912'],
      curveType: "linear",           
       }
    };
    this.dashboard.push({cols: 2, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'KPI2', resizeEnabled: true, label: label, chart: chartd, id: id, filter: null});
    //this.dashObjs.push({cols: 2, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'KPI2', resizeEnabled: true, label: label, chart: '', id: id, filter: null})
    //-----Aqui va el sub de datos para rellenar temp simple
    this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
    this.widgetsElementRef.close();
  }

  addKPI3Widget(id, alias){
    var dummy = id.split("-");;
    let label = dummy[1]+'/'+dummy[2] + ' '+alias;  
    let s = this.dashboard.length;
    let chartd = {
      chartType: 'ColumnChart',
      dataTable: [
        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
        // [' ',  0]
      ],
      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
      borderWidth: 1,
      height: 255,
      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
      animation: {duration: 800, easing: 'inAndOut'},
      hAxis: {
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        textPosition: 'left'
        
       },
      vAxis: {
        format: "short",
        visible: 'true',
        textStyle:{color: '#3f6ab7'},
        titleTextStyle:{color: 'white'},
        gridlines: {color: 'gray'},
        position: 'in',
        viewWindow: {
                      min:0
                    }
      },
      lineWidth: 2.8,
      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
      pointShape: "circle",
      pointSize: 4, 
      pointSizeShadow: 0,
      forcelFrame: "true",
      colors: ['#72b133'],
      curveType: "linear",           
       }
    };
    this.dashboard.push({cols: 2, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'KPI3', resizeEnabled: true, label: label, chart: chartd, id: id, filter: null});
    //this.dashObjs.push({cols: 2, rows: 2, y: 1, x: 0, dragEnabled: true, widgetType: 'KPI3', resizeEnabled: true, label: label, chart: '', id: id, filter: null})
    //-----Aqui va el sub de datos para rellenar temp simple
    this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id'])
    console.log(this.dashboard);
    this.widgetsElementRef.close();
  }

  //-----------Abre ventana de confirmacion----------------
  openConfirmDialog(event, item): void {
      const dialogRef = this.dialog.open(DialogOverviewConfirm, {
        width: '250px',
        data: item
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == "ok"){this.removeItem(event, item)}
      });
    
  }

  removeItem($event: MouseEvent | TouchEvent, item): void {
    $event.preventDefault();
    $event.stopPropagation();
    //se elimina la coneccion con BDD para evitar errores y consumo de memoria.
    let index = this.dashboard.indexOf(item);

    this.dashboard.splice(this.dashboard.indexOf(item), 1);
    //this.explode($event.clientX - 100, $event.clientY);
    //se actualiza el dashboard en backend
    //se quitan los objetos en variable dashboard.
    // let dummyDash = [];
    //   this.dashboard.forEach(element => {
    //     if(element.sub != undefined)
    //       {
    //         element.sub = '';
    //       }
    //     dummyDash.push(element);
    //   });
    this.authService.UpdateUserDashboardGeren(this.app.userUid, this.dashboard, 0, this.app.selectedProyect['id']);
    //this.cdr.detectChanges();
  }

  //filtro para los sites
  private _filter(value: string): Object[] {
    this.Data.filter = value.trim().toLowerCase();
    let result: object[] = [];
    for (let index = 0; index < this.Data.filteredData.length; index++) {
      result.push({'city': this.Data.filteredData[index].city, 'office': this.Data.filteredData[index].office, });
    }
    console.log(result);
    return result;
  }

  //sort menor mayor
  dynamicSort(property) {
    return function(a, b) {
        return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    }
  }

  //sort mayor menor
  dynamicSortAlt(property) {
    return function(a, b) {
        return (a[property] < b[property]) ? 1 : (a[property] > b[property]) ? -1 : 0;
    }
  }

  //animar con codigo
  animate(){
  //indices
  document.getElementById("AnimIndex1").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex2").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex2").style.animationDelay="0.05s"
  document.getElementById("AnimIndex3").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex3").style.animationDelay="0.1s"
  document.getElementById("AnimIndex4").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex4").style.animationDelay="0.15s"
  document.getElementById("AnimIndex5").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex5").style.animationDelay="0.2s"
  document.getElementById("AnimIndex6").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex6").style.animationDelay="0.25s"
  document.getElementById("AnimIndex7").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex7").style.animationDelay="0.3s"
  document.getElementById("AnimIndex8").style.animation="FlipNewA 0.5s linear";
  document.getElementById("AnimIndex8").style.animationDelay="0.35s"
    //tabla
  document.getElementById("row1Anim").style.animation="FlipNewA 0.5s linear";
  document.getElementById("row2Anim").style.animation="FlipNewB 0.5s linear";
  document.getElementById("row2Anim").style.animationDelay="0.1s"
  document.getElementById("row3Anim").style.animation="FlipNewA 0.5s linear";
  document.getElementById("row3Anim").style.animationDelay="0.2s"
  document.getElementById("row4Anim").style.animation="FlipNewRed 0.5s linear";
  document.getElementById("row4Anim").style.animationDelay="0.3s"
  document.getElementById("row5Anim").style.animation="FlipNewB 0.5s linear";
  document.getElementById("row5Anim").style.animationDelay="0.4s"
  document.getElementById("row6Anim").style.animation="FlipNewGreen 0.5s linear";
  document.getElementById("row6Anim").style.animationDelay="0.5s";
  
  
  this.delay(1000).then(any=>{
      document.getElementById("row1Anim").style.animation="";
      document.getElementById("row2Anim").style.animation="";
      document.getElementById("row3Anim").style.animation="";
      document.getElementById("row4Anim").style.animation="";
      document.getElementById("row5Anim").style.animation="";
      document.getElementById("row6Anim").style.animation="";
      document.getElementById("AnimIndex1").style.animation="";
      document.getElementById("AnimIndex2").style.animation="";
      document.getElementById("AnimIndex3").style.animation="";
      document.getElementById("AnimIndex4").style.animation="";
      document.getElementById("AnimIndex5").style.animation="";
      document.getElementById("AnimIndex6").style.animation="";
      document.getElementById("AnimIndex7").style.animation="";
      document.getElementById("AnimIndex8").style.animation="";
  });
  }

  //calcula para tooltip la conversion de Diesel a kWh
  getDieselkWh(value, dims){
    this.equivalentTooltip =  [Math.round(((value*39.75) + Number.EPSILON) * 100) / 100, value, dims];
  }

  //calcula para tooltip la conversion de Gas a kWh
  getGaskWh(value, dims){
    this.equivalentTooltip = [Math.round(((value*12.6389) + Number.EPSILON) * 100) / 100, value, dims];
  }


  ngOnDestroy(){
    this.subMarkers.unsubscribe();
    this.subObserver.unsubscribe();
    //this.sub.unsubscribe();
    this.sizeChange = function() : void {};
    console.log('desuscrito de todo /Home')
  }

  ChangeSpaceTab(id){
    if(id != this.TabIndex) //si no se cambia el indice no se hace nada.....
    {
      this.InitialLoadingPromise = Promise.resolve(true);
      

      // if (this.updateOnExit) {  //se guarda en BDD si es necesario
      //   this.authService.UpdateUserDashboardMonitoring(this.userUid, this.dashboard, this.Snames.indexOf(this.TabIndex), this.appComponent.selectedProyect['id']);
      //   this.updateOnExit = false;
      //   this.snack.open('Cambios Guardados con exito!', '', {duration: 1000})
      // }
      
      let index = this.Snames.indexOf(id); //set the index to new dashboard
      this.TabIndex = id;
      if(this.TabIndex == 'Gerencial')
      {
        this.dashboard = [
          {cols: 2, rows: 2, y: 2, x: 0, dragEnabled: false, widgetType: 'PieConsumers', resizeEnabled: true, minItemCols: 2, label: 'Consumidores Pastel', dataset: null, chart: this.consumersChart},
          {cols: 4, rows: 2, y: 0, x: 0, dragEnabled: false, widgetType: 'GeneralChart', resizeEnabled: true, minItemCols: 2, label: 'Tabla 1'},
          {cols: 4, rows: 2, y: 0, x: 4, dragEnabled: true, widgetType: 'Trendline', resizeEnabled: true, minItemCols: 2, label: 'Grafico', chart: this.MonthsUSDChart},
          {cols: 3, rows: 2, y: 4, x: 5, dragEnabled: false, widgetType: 'Alarms', resizeEnabled: true, minItemCols: 2, label: 'Historico'},
          {cols: 2, rows: 2, y: 2, x: 2, dragEnabled: false, widgetType: 'KPI1', resizeEnabled: true, minItemCols: 2, label: 'KPI1', dataset: null, chart: this.co2Chart},
          {cols: 2, rows: 2, y: 2, x: 4, dragEnabled: false, widgetType: 'KPI2', resizeEnabled: true, minItemCols: 2, label: 'KPI2', dataset: null, chart: this.KPI2Chart},
          {cols: 2, rows: 2, y: 2, x: 6, dragEnabled: false, widgetType: 'KPI3', resizeEnabled: true, minItemCols: 2, label: 'KPI3', dataset: null, chart: this.KPI3Chart},
          {cols: 5, rows: 2, y: 4, x: 0, dragEnabled: false, widgetType: 'YearChart', resizeEnabled: true, minItemCols: 2, label: 'Hitorico 1 Año'},
        ];
        this.delay(500).then(() =>{
          let ccComponent = this.CompareBarsChart.component;
          let ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();

          ccComponent = this.MonthsUSDChart.component;
          ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();

          ccComponent = this.co2Chart.component;
          ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();

          ccComponent = this.KPI1Chart.component;
          ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();

          ccComponent = this.KPI2Chart.component;
          ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();

          ccComponent = this.KPI3Chart.component;
          ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();

          ccComponent = this.consumersChart.component;
          ccwrapper = ccComponent.wrapper;
          //redraw
          ccComponent.draw();

          for(let s in this.dashboard)
          {
            if(this.dashboard[s].chart != undefined)
            {
              ccComponent = this.dashboard[s].chart.component;
              ccwrapper = ccComponent.wrapper;
              //redraw
              ccComponent.draw();
            }
          }

        })
        
      }
      else
      {
        this.delay(500).then(any=>{
          this.dashboard = [];
          this.Spaces = [];
          //this.cdr.detach();
          //this.authService.UpdateUserDashboardMonitoring(this.appComponent.userUid, this.dashboard, "Space1");
          // retrieve spaces alias and dashboards by user
          let sub = this.authService.getUserDashboardMonitoring(this.app.userUid).subscribe( data => {
            let projID = this.app.selectedProyect['id'];
            if(data['GerenSpaces'] != undefined)
            {
              for(let space in data['GerenSpaces'][projID]){
                this.Spaces.push(data['GerenSpaces'][projID][space])
              }
              this.SpaceLimit = data['SpaceLimit'];
              sub.unsubscribe();
              this.TabIndex = this.Snames[1];
              //this.dashObjs = this.Spaces[0];
              //this.InitialLoadingPromise = Promise.resolve(false);//se resuelve la promesa para dibujar el dashboard
              //console.log(this.dashboard);
              //una vez cargado los datos desde Firestore iniciar los subscribe (flujo de datos)
              this.delay(1).then(any =>{  
                /////////////Aqui se deben filtrar los widgets que estan creados            
                for(let s in this.Spaces[0]){                  
                  if(this.Spaces[0][s].widgetType == 'Trendline')
                  {
                    this.Spaces[0][s].chart = {
                      chartType: 'LineChart',
                      dataTable: [
                        // ['M-A', 'CONSUMO (USD)', 'Objetivo (USD)'],
                        // [' ',  1, 4]
                      ],
                      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7', fontName: 'Arial Black'}},
                      borderWidth: 1,
                      height: 250,
                      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
                      animation: {duration: 800, easing: 'inAndOut'},
                      hAxis: {
                        visible: 'true',
                        textPosition: 'left',
                        textStyle:{color: '#3f6ab7'},
                        
                       },
                      vAxis: {
                        format: "short",
                        visible: 'true',
                        textStyle:{color: '#3f6ab7'},
                        titleTextStyle:{color: 'white'},
                        gridlines: {color: 'gray'},
                        position: 'in',
                        viewWindow: {
                                      min:0
                                    }
                      },
                      series: {
                        0: {pointsVisible: true},
                        1: {type: 'line',lineDashStyle: [10, 2]}},
                      options: {
                        responsive: true
                      },
                  
                      //  colors: ['#4875c5', '#a8a8a8', '#619dd6', '#2f4b80'],
                  
                       lineWidth: 2.8,
                  
                      // pointShape: "circle",
                      // pointSize: 4, 
                      // pointSizeShadow: 0,
                      forcelFrame: "true",
                  
                       curveType: "linear",
                                 
                                }
                    };
                    this.dashboard.push(this.Spaces[0][s]);
                    this.filterWidget(this.Spaces[0][s], this.Spaces[0][s].filter)
                  }
                  if(this.Spaces[0][s].widgetType == 'PieConsumers')
                  {
                    this.Spaces[0][s].chart = {
                      chartType: 'PieChart',
                      dataTable: [
                        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
                        // [' ',  0]
                      ],
                      options: { legend: {position: 'right', textStyle:{color: '#3f6ab7'}},
                      borderWidth: 1,
                      height: 255,
                      chartArea: { left: 5, right: 10, top: 30, height: '80%'}, 
                      animation: {duration: 800, easing: 'inAndOut'},
                      hAxis: {
                        visible: 'true',
                        textPosition: 'left'
                        
                       },
                      vAxis: {
                        format: "short",
                        visible: 'true',
                        // textStyle:{color: '#FFF'},
                        titleTextStyle:{color: 'white'},
                        gridlines: {color: 'gray'},
                        position: 'in',
                        viewWindow: {
                                      min:0
                                    }
                      },
                      lineWidth: 2.8,
                      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
                      pointShape: "circle",
                      pointSize: 4, 
                      pointSizeShadow: 0,
                      forcelFrame: "true",
                  
                       curveType: "linear",
                                 
                                }
                    };
                    this.dashboard.push(this.Spaces[0][s]);
                    this.filterWidget(this.Spaces[0][s], this.Spaces[0][s].filter)
                  }
                  if(this.Spaces[0][s].widgetType == 'KPI1')
                  {
                    this.Spaces[0][s].chart = {
                      chartType: 'AreaChart',
                      dataTable: [
                        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
                        // [' ',  0]
                      ],
                      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
                      borderWidth: 1,
                      height: 255,
                      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
                      animation: {duration: 800, easing: 'inAndOut'},
                      hAxis: {
                        visible: 'true',
                        textStyle:{color: '#3f6ab7'},
                        textPosition: 'left'
                        
                       },
                      vAxis: {
                        format: "short",
                        visible: 'true',
                        textStyle:{color: '#3f6ab7'},
                        titleTextStyle:{color: 'white'},
                        gridlines: {color: 'gray'},
                        position: 'in',
                        viewWindow: {
                                      min:0
                                    }
                      },
                      colors: ['#A8A8A8'],
                      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
                      pointShape: "circle",
                      pointSize: 4, 
                      pointSizeShadow: 0,
                      forcelFrame: "true",
                      curveType: "linear",           
                       }
                    };
                    this.dashboard.push(this.Spaces[0][s]);
                    this.filterWidget(this.Spaces[0][s], this.Spaces[0][s].filter)
                  }
                  if(this.Spaces[0][s].widgetType == 'KPI2')
                  {
                    this.Spaces[0][s].chart = {
                      chartType: 'ColumnChart',
                      dataTable: [
                        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
                        // [' ',  0]
                      ],
                      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
                      borderWidth: 1,
                      height: 255,
                      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
                      animation: {duration: 800, easing: 'inAndOut'},
                      hAxis: {
                        visible: 'true',
                        textStyle:{color: '#3f6ab7'},
                        textPosition: 'left'
                        
                       },
                      vAxis: {
                        format: "short",
                        visible: 'true',
                        textStyle:{color: '#3f6ab7'},
                        titleTextStyle:{color: 'white'},
                        gridlines: {color: 'gray'},
                        position: 'in',
                        viewWindow: {
                                      min:0
                                    }
                      },
                      lineWidth: 2.8,
                      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
                      pointShape: "circle",
                      pointSize: 4, 
                      pointSizeShadow: 0,
                      forcelFrame: "true",
                      colors: ['#DC3912'],
                      curveType: "linear",           
                       }
                    };
                    this.dashboard.push(this.Spaces[0][s]);
                    this.filterWidget(this.Spaces[0][s], this.Spaces[0][s].filter)
                  }
                  if(this.Spaces[0][s].widgetType == 'KPI3')
                  {
                    this.Spaces[0][s].chart = {
                      chartType: 'ColumnChart',
                      dataTable: [
                        // ['M-A', 'KPI Consumo/Usuario (USD/Usuario)' ],
                        // [' ',  0]
                      ],
                      options: { legend: {position: 'top', textStyle:{color: '#3f6ab7',fontName: 'Arial Black'}},
                      borderWidth: 1,
                      height: 255,
                      chartArea: { left: 40, right: 10, top: 30, bottom:30, height: '80%'}, 
                      animation: {duration: 800, easing: 'inAndOut'},
                      hAxis: {
                        visible: 'true',
                        textStyle:{color: '#3f6ab7'},
                        textPosition: 'left'
                        
                       },
                      vAxis: {
                        format: "short",
                        visible: 'true',
                        textStyle:{color: '#3f6ab7'},
                        titleTextStyle:{color: 'white'},
                        gridlines: {color: 'gray'},
                        position: 'in',
                        viewWindow: {
                                      min:0
                                    }
                      },
                      lineWidth: 2.8,
                      //colors: ['#0072F0', '#2184F2', '#4296F4', '#62A8F6', '#83BBF8', '#A4CDFA', '#C5DFFC'],
                      pointShape: "circle",
                      pointSize: 4, 
                      pointSizeShadow: 0,
                      forcelFrame: "true",
                      colors: ['#72b133'],
                      curveType: "linear",           
                       }
                    };
                    this.dashboard.push(this.Spaces[0][s]);
                    this.filterWidget(this.Spaces[0][s], this.Spaces[0][s].filter)
                  }
                }
                              
              })
              this.delay(500).then(() =>{
                let ccComponent = this.CompareBarsChart.component;
                let ccwrapper = ccComponent.wrapper;
                //redraw
                ccComponent.draw();
      
                ccComponent = this.MonthsUSDChart.component;
                ccwrapper = ccComponent.wrapper;
                //redraw
                ccComponent.draw();
      
                ccComponent = this.co2Chart.component;
                ccwrapper = ccComponent.wrapper;
                //redraw
                ccComponent.draw();
      
                ccComponent = this.KPI1Chart.component;
                ccwrapper = ccComponent.wrapper;
                //redraw
                ccComponent.draw();
      
                ccComponent = this.KPI2Chart.component;
                ccwrapper = ccComponent.wrapper;
                //redraw
                ccComponent.draw();
      
                ccComponent = this.KPI3Chart.component;
                ccwrapper = ccComponent.wrapper;
                //redraw
                ccComponent.draw();
      
                ccComponent = this.consumersChart.component;
                ccwrapper = ccComponent.wrapper;
                //redraw
                ccComponent.draw();
      
                for(let s in this.dashboard)
                {
                  if(this.dashboard[s].chart != undefined)
                  {
                    ccComponent = this.dashboard[s].chart.component;
                    ccwrapper = ccComponent.wrapper;
                    //redraw
                    ccComponent.draw();
                  }
                }
      
              })
            }
            else
            {
              //this.Snames = ['Personalizado'];
              this.TabIndex = this.Snames[1];
              this.InitialLoadingPromise = Promise.resolve(false);
              this.authService.createUserGerenDash(this.app.userUid, [], this.app.selectedProyect['id']);
            }
          })      
        })
        this.dashboard = []; //aqui cargo el dashboard del usuario
      }      
      this.delay(5).then(any =>{
        for(let s in this.dashboard){
          //aqui filtrara los widgets
          
        }
      });
      this.InitialLoadingPromise = Promise.resolve(false);
    }
    //this.cdr.detectChanges();
  }

  /*
  alarmsID(id: string){
    return this.alarmsService.getAlarmsRTid(id);
  }

  getMarkerIcon(color: number){
    if (color == 1){
      return this.red_marker;
    }
    if (color == 0){
      return this.yellow_marker;
    }
  }
  */

  transformMonth(month){
    let dummy = month.split('-')[0]
    if(dummy == 'Ene'){return 1}
    else if(dummy == 'Feb'){return 2}
    else if(dummy == 'Mar'){return 3}
    else if(dummy == 'Abr'){return 4}
    else if(dummy == 'May'){return 5}
    else if(dummy == 'Jun'){return 6}
    else if(dummy == 'Jul'){return 7}
    else if(dummy == 'Ago'){return 8}
    else if(dummy == 'Sep'){return 9}
    else if(dummy == 'Oct'){return 10}
    else if(dummy == 'Nov'){return 11}
    else if(dummy == 'Dic'){return 12}
    else {return 'error'}
  }

  test( id){
    console.log(id);
    console.log(this.markers);
    return 'once'
  }

  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("delay ", ms));
  }

  findAdress(){
    /*
    this.mapsApiLoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() =>{
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          console.log(place);
          console.log(place.geometry.location.lat());
          console.log(place.geometry.location.lng());
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          this.zoom = 12;
        })
      })
    })
    */
  }

  // title: string = 'Mapa del Ecuador';
  // lat: number = -1.466029;
  // lng: number = -78.386060;
  // zoom: number = 7;

}
